// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"d10jd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m7.788 12.968-3.047-7.5c-.23-.566-1.16-.566-1.39 0l-3.046 7.5c-.156.384.029.821.413.977Q.858 14 1 14c.296 0 .576-.176.695-.468l.927-2.282H5.47l.927 2.282c.158.386.595.568.978.413.384-.156.568-.593.413-.977M3.125 10l.92-2.562L4.97 10zM11.037 14H8.75c-.414 0-.75-.336-.75-.75v-7.5c0-.414.336-.75.75-.75h1.612c1.447 0 2.58 1.129 2.58 2.57 0 .59-.165 1.115-.452 1.535.68.483 1.127 1.295 1.127 2.214 0 1.478-1.157 2.681-2.58 2.681M9.5 12.5h1.537c.596 0 1.08-.53 1.08-1.18 0-.652-.484-1.182-1.08-1.182H9.5zm0-3.562h.959c.597 0 .982-.576.982-1.225 0-.62-.454-1.213-1.079-1.213H9.5zM17.88 14c-2.277 0-4.13-2.019-4.13-4.5 0-2.98 2.657-5.34 5.522-4.222.386.151.578.586.426.972-.15.385-.588.576-.97.426-.303-.118-.58-.176-.848-.176-1.45 0-2.63 1.346-2.63 3s1.18 3 2.63 3c.267 0 .545-.058.848-.176.382-.149.82.04.97.426.152.386-.04.82-.426.972-.479.187-.934.278-1.392.278"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cDsa5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.917 8.15c-.05.01-.88.27-2.1.43-.25.04-.44.25-.44.5v1.14q0 .135.03.27l1.22 4.31c.11.4-.12.81-.52.92-.07.02-.14.03-.2.03-.33 0-.63-.22-.73-.55l-.91-3.25c-.04-.12-.15-.2-.27-.2s-.23.08-.27.2l-.91 3.25c-.1.33-.4.55-.73.55-.06 0-.13-.01-.2-.03-.4-.11-.63-.52-.52-.92l1.22-4.31q.03-.135.03-.27V9.08c0-.25-.19-.46-.44-.49-1.23-.16-2.06-.43-2.11-.45-.39-.13-.6-.55-.47-.94.13-.4.55-.61.94-.48.02 0 1.52.49 3.46.49 1.91 0 3.45-.49 3.46-.49.4-.13.82.09.95.48.12.39-.09.82-.49.95"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 5,
                r: 1.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hkDsd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.352 17.25c0 .414-.336.75-.75.75H2.25C1.01 18 0 16.99 0 15.75v-5.5C0 9.01 1.01 8 2.25 8h10.116c.414 0 .75.336.75.75s-.336.75-.75.75H2.25c-.414 0-.75.336-.75.75v3.837l2.157-2.156c.766-.767 2.014-.767 2.781 0l2.423 2.546c.239.25.228.646-.022.883-.25.238-.646.229-.883-.022l-2.413-2.535c-.269-.268-.723-.267-1.002.011l-3.023 3.023c.045.371.35.663.732.663h6.352c.414 0 .75.336.75.75M5.422 6.795c.397-.116.625-.533.509-.93-.026-.088-.005-.209.102-.28l5-3.315c.165-.11.365-.15.563-.11.196.04.365.154.476.321l4.293 6.483c.144.218.383.336.626.336.142 0 .286-.04.413-.125.345-.229.44-.694.212-1.04l-4.293-6.482c-.332-.502-.84-.844-1.429-.964-.589-.118-1.19-.002-1.69.33l-5 3.317c-.643.427-.93 1.21-.713 1.95.116.398.534.626.93.51m3.864 3.896c-.576 0-1.042.466-1.042 1.042 0 .575.466 1.041 1.042 1.041.575 0 1.041-.466 1.041-1.041 0-.576-.466-1.042-1.041-1.042"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 10.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.5 5.125h-1.875V17.5c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-1.875H12.5c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.875V12.5c0-.345.28-.625.625-.625s.625.28.625.625v1.875H17.5c.345 0 .625.28.625.625s-.28.625-.625.625"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7jtI9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M14.75 15h-1.5C12.01 15 11 13.99 11 12.75v-3.5C11 8.01 12.01 7 13.25 7h1.5C15.99 7 17 8.01 17 9.25v3.5c0 1.24-1.01 2.25-2.25 2.25m-1.5-6.5c-.414 0-.75.337-.75.75v3.5c0 .413.336.75.75.75h1.5c.414 0 .75-.337.75-.75v-3.5c0-.413-.336-.75-.75-.75zM6.75 15h-1.5C4.01 15 3 13.99 3 12.75v-7.5C3 4.01 4.01 3 5.25 3h1.5C7.99 3 9 4.01 9 5.25v7.5C9 13.99 7.99 15 6.75 15M5.25 4.5c-.414 0-.75.337-.75.75v7.5c0 .413.336.75.75.75h1.5c.414 0 .75-.337.75-.75v-7.5c0-.413-.336-.75-.75-.75zM18.25 18H1.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h16.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lJNcY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.25 9.25H17v-1C17 7.01 15.99 6 14.75 6h-1.5C12.01 6 11 7.01 11 8.25v1H9v-3C9 5.01 7.99 4 6.75 4h-1.5C4.01 4 3 5.01 3 6.25v3H1.75c-.414 0-.75.336-.75.75s.336.75.75.75H3v3C3 14.99 4.01 16 5.25 16h1.5C7.99 16 9 14.99 9 13.75v-3h2v1c0 1.24 1.01 2.25 2.25 2.25h1.5c1.24 0 2.25-1.01 2.25-2.25v-1h1.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M7.5 13.75c0 .413-.336.75-.75.75h-1.5c-.414 0-.75-.337-.75-.75v-7.5c0-.413.336-.75.75-.75h1.5c.414 0 .75.337.75.75zm8-2c0 .413-.336.75-.75.75h-1.5c-.414 0-.75-.337-.75-.75v-3.5c0-.413.336-.75.75-.75h1.5c.414 0 .75.337.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3y532":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M14.75 13h-1.5C12.01 13 11 11.99 11 10.75v-3.5C11 6.01 12.01 5 13.25 5h1.5C15.99 5 17 6.01 17 7.25v3.5c0 1.24-1.01 2.25-2.25 2.25m-1.5-6.5c-.414 0-.75.337-.75.75v3.5c0 .413.336.75.75.75h1.5c.414 0 .75-.337.75-.75v-3.5c0-.413-.336-.75-.75-.75zM6.75 17h-1.5C4.01 17 3 15.99 3 14.75v-7.5C3 6.01 4.01 5 5.25 5h1.5C7.99 5 9 6.01 9 7.25v7.5C9 15.99 7.99 17 6.75 17M5.25 6.5c-.414 0-.75.337-.75.75v7.5c0 .413.336.75.75.75h1.5c.414 0 .75-.337.75-.75v-7.5c0-.413-.336-.75-.75-.75zM18.25 3.5H1.75c-.414 0-.75-.336-.75-.75S1.336 2 1.75 2h16.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bd98e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M6.5 19C3.468 19 1 16.532 1 13.5c0-2.392 1.527-4.494 3.8-5.232.4-.126.818.088.946.482.127.394-.089.817-.482.945C3.61 10.231 2.5 11.761 2.5 13.5c0 2.206 1.794 4 4 4 1.747 0 3.278-1.117 3.812-2.78.126-.394.545-.609.942-.485.394.126.612.548.485.943C11.007 17.464 8.901 19 6.5 19M15.217 12.05c-.203 0-.405-.081-.553-.242-.28-.306-.26-.78.046-1.06.51-.467.79-1.104.79-1.794 0-1.353-1.1-2.454-2.454-2.454-.687 0-1.324.281-1.796.791-.283.304-.757.32-1.06.041-.304-.282-.323-.757-.042-1.06C10.898 5.463 11.953 5 13.046 5 15.226 5 17 6.773 17 8.954c0 1.099-.465 2.155-1.276 2.9-.144.131-.326.197-.507.197M17.885 5.832c-.144 0-.29-.041-.418-.128-.344-.23-.435-.697-.203-1.04.153-.228.234-.496.234-.772 0-.766-.622-1.388-1.387-1.388-.499 0-.963.278-1.209.726-.2.363-.657.497-1.018.296-.363-.199-.495-.655-.296-1.018.51-.928 1.476-1.504 2.523-1.504 1.592 0 2.887 1.296 2.887 2.888 0 .576-.169 1.131-.49 1.609-.145.215-.382.331-.623.331M18.25 19c-.192 0-.384-.073-.53-.22L1.22 2.28c-.293-.293-.293-.767 0-1.06s.767-.293 1.06 0l16.5 16.5c.293.293.293.767 0 1.06-.146.147-.338.22-.53.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7K1NW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M1 13.5C1 10.468 3.467 8 6.5 8s5.5 2.468 5.5 5.5S9.533 19 6.5 19 1 16.532 1 13.5m1.5 0c0 2.206 1.794 4 4 4s4-1.794 4-4-1.794-4-4-4-4 1.794-4 4M14.097 12.72q.124 0 .247-.041C15.933 12.126 17 10.629 17 8.954 17 6.774 15.226 5 13.046 5c-1.18 0-2.29.526-3.047 1.444-.116.141-.172.31-.172.478 0 .216.093.43.273.579.32.264.793.218 1.056-.102.47-.57 1.16-.899 1.89-.899 1.353 0 2.454 1.1 2.454 2.454 0 1.037-.663 1.965-1.65 2.309-.309.107-.503.397-.503.708q0 .122.042.247c.108.31.398.503.708.503M17.885 5.832c.241 0 .478-.116.623-.331.32-.478.49-1.033.49-1.61 0-1.591-1.295-2.887-2.887-2.887-1.048 0-2.014.576-2.524 1.505-.199.362-.066.818.297 1.017.364.2.82.068 1.019-.297.245-.447.708-.725 1.208-.725.765 0 1.387.622 1.387 1.388 0 .276-.081.544-.235.771-.23.344-.14.81.204 1.041.129.087.274.128.418.128"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k0X7J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 3.5,
                height: 3.5,
                x: 2.25,
                y: 2.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 3.5,
                height: 3.5,
                x: 8.25,
                y: 2.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 3.5,
                height: 3.5,
                x: 14.25,
                y: 2.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 3.5,
                height: 3.5,
                x: 2.25,
                y: 8.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 3.5,
                height: 3.5,
                x: 8.25,
                y: 8.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 3.5,
                height: 3.5,
                x: 14.25,
                y: 8.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 3.5,
                height: 3.5,
                x: 2.25,
                y: 14.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 3.5,
                height: 3.5,
                x: 8.25,
                y: 14.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 3.5,
                height: 3.5,
                x: 14.25,
                y: 14.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                rx: 1,
                ry: 1
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8M00f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M5.75 18.003h-1.5c-1.24 0-2.25-1.01-2.25-2.25v-1.5c0-1.24 1.01-2.25 2.25-2.25h1.5c1.24 0 2.25 1.01 2.25 2.25v1.5c0 1.24-1.01 2.25-2.25 2.25m-1.5-4.5c-.413 0-.75.337-.75.75v1.5c0 .413.337.75.75.75h1.5c.413 0 .75-.337.75-.75v-1.5c0-.413-.337-.75-.75-.75zM5.75 11.003h-1.5c-1.24 0-2.25-1.01-2.25-2.25v-1.5c0-1.24 1.01-2.25 2.25-2.25h1.5c1.24 0 2.25 1.01 2.25 2.25v1.5c0 1.24-1.01 2.25-2.25 2.25m-1.5-4.5c-.413 0-.75.337-.75.75v1.5c0 .413.337.75.75.75h1.5c.413 0 .75-.337.75-.75v-1.5c0-.413-.337-.75-.75-.75zM12.75 18.003h-1.5c-1.24 0-2.25-1.01-2.25-2.25v-1.5c0-1.24 1.01-2.25 2.25-2.25h1.5c1.24 0 2.25 1.01 2.25 2.25v1.5c0 1.24-1.01 2.25-2.25 2.25m-1.5-4.5c-.413 0-.75.337-.75.75v1.5c0 .413.337.75.75.75h1.5c.413 0 .75-.337.75-.75v-1.5c0-.413-.337-.75-.75-.75zM15.251 11.003h-3.5c-1.517 0-2.75-1.233-2.75-2.75v-3.5c0-1.517 1.233-2.75 2.75-2.75h3.5c1.517 0 2.75 1.233 2.75 2.75v3.5c0 1.517-1.233 2.75-2.75 2.75m-3.5-7.5c-.69 0-1.25.56-1.25 1.25v3.5c0 .69.56 1.25 1.25 1.25h3.5c.69 0 1.25-.56 1.25-1.25v-3.5c0-.69-.56-1.25-1.25-1.25z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2NbrT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v1c0 .778.398 1.465 1 1.869v6.631C2 15.99 3.01 17 4.25 17h11.5c1.24 0 2.25-1.01 2.25-2.25V8.119c.602-.404 1-1.09 1-1.869v-1C19 4.01 17.99 3 16.75 3M2.5 5.25c0-.413.336-.75.75-.75h13.5c.414 0 .75.337.75.75v1c0 .413-.336.75-.75.75H3.25c-.414 0-.75-.337-.75-.75zM15.75 15.5H4.25c-.414 0-.75-.337-.75-.75V8.5h13v6.25c0 .413-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.25 10.5h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"la2Hs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.25 2H13c-.414 0-.75.336-.75.75s.336.75.75.75h2.44L2.344 16.594c-.293.293-.293.768 0 1.06.147.147.339.22.53.22s.384-.073.53-.22L16.5 4.562V7c0 .414.336.75.75.75S18 7.414 18 7V2.75c0-.414-.336-.75-.75-.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"UmfPO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m17.34 8.28-3.62-3.62c-.42-.42-1-.66-1.591-.66H6.25C5.01 4 4 5.01 4 6.25v9.5C4 16.99 5.01 18 6.25 18h9.5c1.24 0 2.25-1.01 2.25-2.25V9.871c0-.592-.24-1.172-.66-1.59m-1.06 1.06c.046.046.074.105.106.16H13.25c-.413 0-.75-.336-.75-.75V5.614c.055.032.114.06.16.106zm-.53 7.16h-9.5c-.413 0-.75-.336-.75-.75v-9.5c0-.414.337-.75.75-.75H11v3.25C11 9.99 12.01 11 13.25 11h3.25v4.75c0 .414-.337.75-.75.75M4.75 3.5c-.414 0-.75-.336-.75-.75V1c0-.414.336-.75.75-.75s.75.336.75.75v1.75c0 .414-.336.75-.75.75M2.75 5.5H1c-.414 0-.75-.336-.75-.75S.586 4 1 4h1.75c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"01pVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.75 18h-3.5C2.01 18 1 16.99 1 15.75v-3.5C1 11.01 2.01 10 3.25 10h3.5C7.99 10 9 11.01 9 12.25v3.5C9 16.99 7.99 18 6.75 18m-3.5-6.5c-.414 0-.75.336-.75.75v3.5c0 .414.336.75.75.75h3.5c.414 0 .75-.336.75-.75v-3.5c0-.414-.336-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.75 15h-1.531c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.531c.414 0 .75-.336.75-.75v-4.5c0-.414-.336-.75-.75-.75h-9.5c-.367 0-.677.261-.74.621-.07.409-.457.681-.865.612-.41-.07-.683-.458-.613-.866C1.218 6.785 2.152 6 3.25 6h9.5C13.99 6 15 7.01 15 8.25v4.5c0 1.24-1.01 2.25-2.25 2.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17.334 10.882c-.292 0-.57-.171-.69-.457-.162-.382.016-.821.398-.983.278-.118.458-.39.458-.692v-4.5c0-.414-.336-.75-.75-.75H3.25c-.365 0-.684.271-.74.63-.066.41-.445.69-.86.623-.408-.065-.687-.449-.622-.858C1.202 2.797 2.137 2 3.25 2h13.5C17.99 2 19 3.01 19 4.25v4.5c0 .906-.54 1.72-1.374 2.073q-.144.06-.292.06"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cyNrR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.664 4.921c0 .696-.578 1.26-1.292 1.26S9.08 5.617 9.08 4.921s.578-1.26 1.292-1.26 1.292.564 1.292 1.26M16.75 19h-6.5C9.01 19 8 17.99 8 16.75v-6.5C8 9.01 9.01 8 10.25 8h6.5C17.99 8 19 9.01 19 10.25v6.5c0 1.24-1.01 2.25-2.25 2.25m-6.5-9.5c-.413 0-.75.337-.75.75v6.5c0 .413.337.75.75.75h6.5c.413 0 .75-.337.75-.75v-6.5c0-.413-.337-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12 15.132v-2.907c0-.429.414-.69.733-.463l2.35 1.453c.301.214.301.712 0 .926l-2.35 1.453c-.319.228-.733-.034-.733-.462M13.022 1H2.978C1.887 1 1 1.901 1 3.01v7.98C1 12.1 1.887 13 2.978 13H5.75c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H2.978c-.264 0-.478-.229-.478-.51v-.773l2.595-2.53c.165-.162.445-.164.604-.008l.478.477c.293.293.767.293 1.06 0s.293-.767 0-1.06l-.484-.485c-.742-.725-1.956-.726-2.704 0L2.5 8.122V3.01c0-.281.214-.51.478-.51h10.044c.264 0 .478.229.478.51V5.7c0 .414.336.75.75.75s.75-.336.75-.75V3.01C15 1.9 14.113 1 13.022 1"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5Pkgy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.026 18.898h-.001c-1.342 0-2.603-.522-3.548-1.47-.947-.946-1.469-2.206-1.469-3.549s.522-2.603 1.469-3.55l8.012-8c.79-.791 1.804-1.227 2.853-1.227 1.02 0 1.897.358 2.603 1.064.784.785 1.155 1.802 1.043 2.866-.097.925-.543 1.828-1.258 2.541l-5.336 5.322c-.072.078-.904.94-2.01.96-.604.019-1.158-.23-1.622-.693-1.21-1.21-.856-2.649.032-3.537L12.3 5.103c.292-.292.767-.294 1.06-.001.294.292.295.767.002 1.06l-4.507 4.523c-.33.331-.604.844-.033 1.416.232.231.431.262.531.254.4-.005.841-.376.965-.505l5.353-5.339c.464-.463.765-1.06.826-1.636.065-.622-.142-1.176-.613-1.648-.42-.42-.925-.625-1.542-.625-.648 0-1.285.28-1.793.788l-8.012 8c-.663.663-1.029 1.547-1.029 2.49 0 .94.366 1.825 1.03 2.489.663.664 1.546 1.029 2.487 1.03.943 0 1.827-.366 2.49-1.03l6.974-6.973c.293-.293.767-.293 1.06 0s.293.768 0 1.06l-6.973 6.973c-.947.947-2.207 1.47-3.55 1.47"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jF3g4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M2.75 11.75c-.414 0-.75-.336-.75-.75V8.5c0-.414.336-.75.75-.75s.75.336.75.75V11c0 .414-.336.75-.75.75M16.75 12.75c-.414 0-.75-.336-.75-.75V7.5c0-.414.336-.75.75-.75s.75.336.75.75V12c0 .414-.336.75-.75.75M6.25 16.5c-.414 0-.75-.336-.75-.75v-12c0-.414.336-.75.75-.75s.75.336.75.75v12c0 .414-.336.75-.75.75M9.75 14.5c-.414 0-.75-.336-.75-.75v-8c0-.414.336-.75.75-.75s.75.336.75.75v8c0 .414-.336.75-.75.75M13.25 19c-.414 0-.75-.336-.75-.75V1.75c0-.414.336-.75.75-.75s.75.336.75.75v16.5c0 .414-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gpJrx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 12.003c-1.91 0-3.463-1.629-3.463-3.632S8.091 4.74 10 4.74s3.463 1.63 3.463 3.632-1.554 3.632-3.463 3.632m0-5.764c-1.082 0-1.963.956-1.963 2.132s.881 2.132 1.963 2.132 1.963-.956 1.963-2.132S11.082 6.24 10 6.24M14.916 18.679c-.414 0-.75-.336-.75-.75 0-2.81-2.61-3.23-4.166-3.23-1.253 0-4.166.314-4.166 3.23 0 .414-.336.75-.75.75s-.75-.336-.75-.75c0-2.918 2.17-4.73 5.666-4.73s5.666 1.812 5.666 4.73c0 .414-.336.75-.75.75M18 18.747c-.414 0-.75-.336-.75-.75q0-.306-.015-.589c-.02-.413.3-.764.713-.785.386-.028.766.299.785.713q.017.318.017.661c0 .414-.336.75-.75.75M10.612 1.557c-.437-.045-.895-.044-1.323-.005-.413.037-.718.401-.68.813.037.413.399.708.813.68.339-.03.7-.027 1.046.004q.037.004.073.004c.382 0 .708-.29.745-.678.04-.412-.262-.78-.674-.818M4.53 9.765c-.362.2-.494.656-.295 1.02.112.201.23.432.227.672-.049.411.244.784.655.834q.045.005.091.005c.374 0 .698-.28.744-.661q.014-.117.014-.234c0-.514-.2-.949-.416-1.341-.2-.363-.655-.495-1.02-.295M2.733 12.983c-.325.326-.6.725-.816 1.186-.176.375-.015.821.36.997q.156.072.318.071c.282 0 .552-.159.68-.431.142-.303.317-.56.519-.762.293-.293.293-.768 0-1.06s-.768-.294-1.06 0M6.276 2.656c-.357.256-.695.557-1.003.895-.278.305-.256.78.05 1.06.144.13.324.195.505.195.203 0 .406-.082.555-.245q.356-.391.766-.684c.337-.241.414-.709.174-1.047-.24-.335-.707-.416-1.047-.174M2 18.679c-.414 0-.75-.336-.75-.75q0-.343.014-.656c.015-.415.401-.74.778-.72.414.016.736.365.72.779q-.011.285-.012.597c0 .414-.336.75-.75.75M17.361 15.355c-.282 0-.551-.159-.68-.43-.147-.313-.325-.594-.528-.834-.267-.317-.228-.79.088-1.057s.788-.23 1.057.088c.288.34.538.733.741 1.164.177.374.016.821-.36.998-.102.049-.211.071-.318.071M14.927 12.27c-.414 0-.75-.317-.75-.73v-.038c0-.517.172-.98.285-1.286.143-.386.588-.626.977-.486.388.143.604.53.462.918-.118.32-.224.606-.224.854 0 .414-.336.769-.75.769M15.666 8.34c-.413 0-.749-.334-.75-.747-.001-.368-.037-.708-.107-1.011-.094-.403.157-.807.56-.9.398-.098.806.156.9.56.096.412.146.865.147 1.347.001.414-.334.75-.748.752zM4.332 8.34c-.414 0-.749-.337-.748-.751.001-.482.05-.935.146-1.347.095-.404.503-.658.9-.56.404.093.655.497.561.9-.07.303-.106.643-.107 1.01-.001.414-.337.749-.75.749zM14.123 4.728c-.193 0-.387-.075-.533-.223-.241-.244-.509-.463-.796-.651-.346-.228-.442-.694-.215-1.04.229-.345.693-.44 1.04-.214.373.246.723.532 1.037.85.291.294.29.77-.006 1.06-.145.145-.337.218-.527.218"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kN69E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.752 2H4.262C3.024 2 2.016 3.01 2.016 4.25v4.704L2 8.97l.015.014v5.274L2 14.27l.015.015v1.464c0 1.24 1.008 2.25 2.248 2.25h11.49C16.99 18 18 16.99 18 15.75V4.25C18 3.01 16.991 2 15.752 2m.75 8.447L10.454 16.5h-3.18l9.226-9.234zM3.512 4.25c0-.413.337-.75.75-.75h3.2l-3.95 3.954zm0 5.325L9.583 3.5h3.179l-9.249 9.257zm0 6.175v-.872L14.881 3.5h.871c.413 0 .75.337.75.75v.895L5.155 16.5h-.893c-.413 0-.75-.337-.75-.75m12.24.75h-3.179l3.927-3.931v3.181c0 .413-.336.75-.749.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4xe3L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.749c-.33 0-.659-.063-.965-.191-.635-.264-1.17-.706-1.55-1.28-.208-.264-.56-.407-.904-.366-.637.138-1.32.077-1.948-.179-.616-.25-1.114-.748-1.366-1.367-.255-.625-.315-1.306-.174-1.97.037-.327-.113-.687-.386-.895-.547-.353-.998-.893-1.266-1.536-.254-.613-.254-1.317 0-1.93.268-.643.719-1.183 1.304-1.563.235-.181.385-.541.342-.89-.135-.64-.075-1.321.18-1.947.251-.62.75-1.117 1.368-1.368.625-.253 1.306-.317 1.969-.174.322.033.676-.108.885-.373.378-.573.911-1.014 1.545-1.279.614-.253 1.317-.254 1.93 0 .633.264 1.165.704 1.543 1.272.207.27.563.418.911.374.64-.134 1.32-.076 1.949.178.617.253 1.114.75 1.366 1.367.255.629.315 1.31.174 1.973-.036.32.108.674.374.884.572.378 1.014.912 1.278 1.546.254.613.254 1.317 0 1.93-.268.643-.719 1.183-1.304 1.563-.235.181-.385.541-.342.89.135.642.075 1.323-.18 1.95-.252.617-.75 1.115-1.367 1.366-.627.256-1.309.316-1.973.172-.327-.044-.686.115-.891.387q-.016.022-.034.042c-.406.576-.911.977-1.504 1.223-.306.128-.634.191-.964.191m-1.307-2.362q.046.06.079.126c.172.256.477.51.839.66.247.102.53.104.777 0 .363-.15.668-.404.882-.735q.016-.025.037-.051c.526-.696 1.394-1.068 2.281-.965l.122.017c.368.08.743.046 1.09-.094.246-.1.444-.297.543-.543.142-.348.175-.726.097-1.094l-.016-.099c-.108-.89.261-1.77.961-2.301.384-.252.637-.557.788-.92.103-.246.103-.53 0-.777-.15-.362-.404-.667-.734-.88q-.03-.02-.06-.044c-.702-.546-1.062-1.416-.956-2.288.003-.021.012-.086.017-.108.079-.367.045-.745-.097-1.094-.1-.245-.297-.443-.542-.543-.347-.14-.725-.175-1.092-.094l-.106.016c-.884.104-1.754-.26-2.285-.948q-.027-.035-.048-.066c-.214-.33-.519-.584-.882-.736-.246-.101-.531-.101-.777 0-.362.152-.667.405-.88.736q-.035.052-.078.1c-.56.68-1.41 1.02-2.254.914-.022-.002-.085-.012-.106-.016-.37-.079-.747-.044-1.094.096-.245.1-.443.298-.543.543-.14.348-.174.726-.096 1.093l.016.099c.108.89-.261 1.77-.961 2.301-.384.252-.637.557-.788.92-.103.246-.103.53 0 .777.15.362.404.667.734.88.754.57 1.123 1.45 1.016 2.332-.003.021-.012.086-.017.107-.078.368-.045.746.096 1.093.1.247.298.444.542.543.35.142.726.176 1.092.095.026-.005.075-.012.102-.014.894-.107 1.77.26 2.301.962"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.038 13.33c-.274 0-.533-.122-.708-.332l-1.537-1.843c-.325-.39-.272-.971.119-1.298.39-.326.971-.272 1.297.119l.808.967 2.76-3.512c.314-.4.893-.471 1.294-.156.4.315.47.894.155 1.294l-3.464 4.409c-.172.218-.433.347-.711.352z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cQVAx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.557 5.128c-.559-1.419-1.628-2.53-3.012-3.125-1.382-.595-2.923-.612-4.339-.044-1.405.564-2.505 1.63-3.095 3-.699 1.622-1.903 2.499-3.177 3.427-.35.255-.7.51-1.044.782-.621.49-.93 1.254-.827 2.043.105.798.608 1.463 1.344 1.78l4.152 1.79c-.197.38-.309.802-.309 1.24 0 1.517 1.233 2.75 2.75 2.75 1.192 0 2.198-.765 2.58-1.827l1.487.641c.29.125.594.186.896.186.466 0 .927-.146 1.321-.433.648-.47.99-1.224.917-2.018-.032-.35-.072-.691-.112-1.029-.193-1.646-.359-3.065.412-4.854.59-1.369.61-2.899.056-4.31M10 17.27c-.69 0-1.25-.56-1.25-1.25 0-.23.065-.453.187-.646l2.268.978c-.145.529-.63.918-1.205.918m6.124-8.428c-.93 2.157-.724 3.919-.524 5.622q.059.488.107.994c.035.376-.201.59-.304.665-.105.076-.386.235-.742.084l-10.66-4.594c-.247-.106-.415-.33-.45-.598-.017-.125-.024-.44.268-.671.328-.26.664-.503.998-.746 1.381-1.006 2.81-2.047 3.671-4.046.433-1.004 1.241-1.786 2.278-2.202.507-.205 1.038-.306 1.565-.306.552 0 1.102.111 1.62.335 1.014.436 1.799 1.253 2.21 2.297.408 1.039.396 2.163-.037 3.166"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2370J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13 2.5H7c-.414 0-.75-.336-.75-.75S6.586 1 7 1h6c.414 0 .75.336.75.75s-.336.75-.75.75M16.773 14.48q-.022-.046-.05-.09L12.49 7.78V5.493h.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25c-.414 0-.75.336-.75.75V8c0 .144.041.284.119.404l1.171 1.83-5.686 1.743 2.279-3.574c.076-.12.117-.26.117-.403V4.743c0-.414-.336-.75-.75-.75H6.99c-.414 0-.75.336-.75.75s.336.75.75.75h.5v2.288l-4.213 6.61q-.028.043-.049.09c-.351.761-.29 1.638.164 2.346C3.86 17.562 4.67 18 5.558 18h8.884c.887 0 1.697-.438 2.167-1.173.453-.708.515-1.585.164-2.347m-1.427 1.539c-.193.301-.531.481-.904.481H5.558c-.373 0-.71-.18-.904-.481-.171-.268-.2-.582-.082-.87l.779-1.222 7.768-2.383 2.31 3.604c.117.29.088.604-.083.87"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gj1GO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.62 12.904-1.915-8.588c-.26-1.275-1.392-2.2-2.695-2.2-1.517 0-2.75 1.233-2.75 2.75v.51c-.377-.194-.798-.314-1.25-.314s-.874.12-1.25.314v-.51c0-1.517-1.234-2.75-2.75-2.75-1.303 0-2.437.925-2.693 2.186L1.4 12.904c-.082.309-.14.627-.14.961 0 2.068 1.682 3.75 3.75 3.75 2.066 0 3.749-1.681 3.75-3.748v-2.002c0-.69.56-1.25 1.25-1.25s1.25.56 1.25 1.25v2.002c0 1.001.39 1.942 1.097 2.65.708.709 1.65 1.098 2.652 1.098 2.067 0 3.75-1.681 3.75-3.75 0-.334-.057-.652-.14-.961m-4.61-9.289c.592 0 1.107.421 1.228 1.015l1.307 5.822c-.47-.212-.987-.337-1.535-.337-.848 0-1.622.293-2.25.77v-6.02c0-.69.56-1.25 1.25-1.25m-9.226 1c.117-.579.633-1 1.226-1 .69 0 1.25.56 1.25 1.25v6.02c-.629-.476-1.403-.77-2.25-.77-.549 0-1.066.125-1.536.338zm.226 11.5c-1.24 0-2.25-1.01-2.25-2.25s1.01-2.25 2.25-2.25 2.25 1.01 2.25 2.25-1.01 2.25-2.25 2.25m5-7c-.453 0-.874.12-1.25.315V7.812c0-.69.56-1.25 1.25-1.25s1.25.56 1.25 1.25V9.43c-.377-.195-.798-.315-1.25-.315m4.999 7c-.6 0-1.166-.234-1.591-.659s-.658-.99-.658-1.59c0-1.241 1.01-2.25 2.25-2.25s2.25 1.009 2.25 2.25c-.001 1.24-1.011 2.25-2.251 2.25"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"krWIU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 18.75c-3.848 0-6.75-2.703-6.75-6.288 0-2.736 2.32-5.784 4.365-8.474.655-.86 1.273-1.67 1.761-2.404.277-.418.97-.418 1.248 0 .488.733 1.106 1.545 1.76 2.404 2.047 2.69 4.366 5.738 4.366 8.474 0 3.585-2.902 6.288-6.75 6.288m0-15.441c-.37.508-.772 1.039-1.19 1.587-1.904 2.501-4.06 5.335-4.06 7.566 0 2.774 2.208 4.788 5.25 4.788s5.25-2.014 5.25-4.788c0-2.23-2.156-5.065-4.06-7.566-.418-.548-.82-1.079-1.19-1.587"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dU6kd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M5.251 19q-.242 0-.478-.096c-.47-.193-.773-.647-.773-1.155v-13.5C4 3.01 5.01 2 6.25 2h7.5C14.99 2 16 3.01 16 4.25v13.5c0 .508-.304.962-.773 1.155-.471.195-1.005.087-1.364-.274L10 14.743 6.137 18.63c-.24.242-.56.37-.886.37M6.25 3.5c-.413 0-.75.337-.75.75v12.892l3.436-3.456c.57-.572 1.56-.571 2.127 0l3.437 3.456V4.25c0-.413-.337-.75-.75-.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b2D5l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.007 19q-.126 0-.253-.004c-4.422-.25-7.818-3.902-7.753-8.311V3.25c0-1.24 1.01-2.25 2.25-2.25H15.75C16.99 1 18 2.01 18 3.25l-.003 7.99c-.066 2.14-.959 4.123-2.516 5.587C13.985 18.233 12.05 19 10.007 19M4.25 2.5c-.413 0-.75.337-.75.75v7.445c-.054 3.615 2.722 6.598 6.32 6.802 1.706.052 3.367-.573 4.632-1.763s1.991-2.8 2.044-4.537L16.5 11V3.25c0-.413-.337-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.25 12h-5.5c-.265 0-.51-.14-.645-.367-.135-.228-.14-.51-.013-.742l2.75-5.04c.133-.24.385-.39.659-.39s.527.15.658.39l2.75 5.04c.126.232.121.514-.014.742s-.38.367-.645.367m-4.236-1.5h2.972l-1.485-2.724zM5.749 12c-.121 0-.244-.03-.358-.092-.364-.198-.497-.654-.3-1.017l1.982-3.63c.198-.363.654-.497 1.018-.298.363.198.497.654.299 1.017l-1.982 3.63c-.136.248-.393.39-.659.39"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1nyHS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.973 5.054h-1.5v-1.74c0-.419-.396-.814-.815-.814h-5.47c-.399 0-.688.315-.688.75v1.74H5V3.25C5 1.988 5.96 1 7.188 1h5.47c1.234 0 2.315 1.081 2.315 2.314z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 17H3.25C2.01 17 1 15.99 1 14.75v-8.5C1 5.01 2.01 4 3.25 4h13.5C17.99 4 19 5.01 19 6.25v8.5c0 1.24-1.01 2.25-2.25 2.25M3.25 5.5c-.413 0-.75.337-.75.75v8.5c0 .413.337.75.75.75h13.5c.413 0 .75-.337.75-.75v-8.5c0-.413-.337-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M2 9.25h16v1.5H2z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M5.75 12.25c-.414 0-.75-.336-.75-.75V9c0-.414.336-.75.75-.75s.75.336.75.75v2.5c0 .414-.336.75-.75.75M14.25 12.25c-.414 0-.75-.336-.75-.75V9c0-.414.336-.75.75-.75s.75.336.75.75v2.5c0 .414-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8zJWv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 3.013c-.414 0-.75-.336-.75-.75V1.25c0-.414.336-.75.75-.75s.75.336.75.75v1.013c0 .414-.336.75-.75.75M10 19.5c-.414 0-.75-.336-.75-.75v-1c0-.414.336-.75.75-.75s.75.336.75.75v1c0 .414-.336.75-.75.75M18.75 10.75h-.999c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.999c.414 0 .75.336.75.75s-.336.75-.75.75M2.245 10.75H1.25c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h.995c.414 0 .75.336.75.75s-.336.75-.75.75M4.52 5.27c-.193 0-.384-.074-.53-.22l-.708-.707c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l.708.706c.293.293.293.768 0 1.06-.147.147-.338.22-.53.22M16.188 16.938c-.193 0-.384-.074-.53-.22l-.706-.705c-.293-.293-.293-.768 0-1.06s.768-.294 1.06 0l.706.704c.293.293.293.768 0 1.06-.147.147-.338.22-.53.22M15.477 5.269c-.193 0-.386-.075-.533-.222-.292-.294-.29-.769.004-1.06l.711-.707c.294-.292.769-.29 1.06.004s.29.769-.003 1.06l-.711.707c-.147.145-.337.218-.528.218M3.813 16.938c-.193 0-.385-.074-.532-.221-.292-.293-.292-.768.002-1.06l.707-.706c.293-.292.768-.292 1.06.002.293.293.293.768-.001 1.06l-.707.706c-.147.145-.338.218-.53.218M10 4c-3.308 0-6 2.692-6 6s2.692 6 6 6 6-2.692 6-6-2.692-6-6-6m-4.5 6c0-2.481 2.019-4.5 4.5-4.5v9c-2.481 0-4.5-2.019-4.5-4.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lKS2A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.074 1.6c-.528-.44-1.192-.654-1.883-.587-.685.061-1.306.386-1.745.912-.036.043-5.03 6.019-6.693 8.012-.344.016-.693.067-1.042.164-1.973.546-2.687 2.232-3.315 3.718-.501 1.184-.975 2.302-2.003 2.859-.287.154-.44.476-.38.797.06.319.318.564.641.606.936.12 1.977.208 3.024.208 2.16 0 4.351-.372 5.72-1.594.925-.825 1.385-1.937 1.366-3.306-.001-.063-.02-.122-.024-.184l1.206-1.443c2.103-2.517 5.381-6.443 5.455-6.53.912-1.09.765-2.72-.327-3.631M9.4 15.576c-1.052.94-3.109 1.345-5.865 1.18.554-.725.91-1.57 1.241-2.35.57-1.345 1.06-2.506 2.335-2.86.875-.24 1.732-.112 2.354.353.5.375.79.926.799 1.512.012.927-.27 1.636-.864 2.165m7.853-11.308c-.043.05-3.345 4.002-5.458 6.533l-.634.76c-.218-.32-.472-.619-.797-.862-.273-.204-.574-.36-.89-.484 2.01-2.407 6.059-7.251 6.122-7.325.183-.221.443-.357.73-.383.292-.023.566.062.787.247.456.38.518 1.061.14 1.514"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6y5M5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.25 10h-1.5c0-1.327-.278-2.577-.763-3.68.644-.397 1.246-.853 1.784-1.375.298-.288.306-.762.018-1.06-.287-.298-.762-.306-1.06-.018-.444.43-.936.81-1.463 1.14C14.027 3.178 12.129 2 10 2S5.973 3.177 4.734 5.008c-.527-.331-1.02-.712-1.463-1.14-.297-.289-.772-.281-1.06.017s-.28.772.018 1.06c.538.522 1.14.978 1.784 1.375C3.528 7.423 3.25 8.673 3.25 10h-1.5c-.414 0-.75.336-.75.75s.336.75.75.75h1.623c.176 1.094.538 2.11 1.049 2.997-.955.643-1.751 1.443-2.312 2.362-.216.354-.104.815.25 1.03.121.076.256.111.389.111.253 0 .5-.128.64-.36.456-.744 1.111-1.395 1.901-1.92C6.508 17.128 8.17 18 10 18s3.492-.872 4.71-2.28c.79.525 1.445 1.176 1.9 1.92.141.232.388.36.641.36.133 0 .268-.035.39-.11.353-.216.465-.677.249-1.03-.56-.92-1.357-1.72-2.312-2.363.515-.894.878-1.918 1.052-3.021.04.007.078.024.12.024h1.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M10 3.5c1.562 0 2.962.853 3.925 2.198-1.217.516-2.555.802-3.925.802s-2.708-.286-3.925-.802C7.038 4.353 8.438 3.5 10 3.5M6.15 14.404c-.007-.014-.006-.03-.013-.043-.037-.067-.09-.118-.143-.169C5.22 13.06 4.75 11.597 4.75 10c0-1.078.216-2.093.593-2.989 1.218.538 2.543.865 3.907.954v8.46c-1.219-.217-2.302-.952-3.1-2.021m4.6 2.022V7.965c1.365-.089 2.689-.416 3.907-.954.377.896.593 1.911.593 2.989 0 1.598-.47 3.061-1.246 4.195-.052.05-.104.1-.14.166-.008.014-.007.029-.014.043-.798 1.07-1.881 1.804-3.1 2.022"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"28VQl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 12,
                cy: 5,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8,
                cy: 8,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8,
                cy: 5,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 12,
                cy: 8,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.75 1h-9.5C4.01 1 3 2.01 3 3.25v12.5C3 16.99 4.01 18 5.25 18h9.5c1.24 0 2.25-1.01 2.25-2.25V3.25C17 2.01 15.99 1 14.75 1m-3.251 15.5H9v-3.25c0-.413.337-.75.75-.75h.999c.413 0 .75.337.75.75zm4.001-.75c0 .413-.337.75-.75.75h-1.751v-3.25c0-1.24-1.01-2.25-2.25-2.25H9.75c-1.24 0-2.25 1.01-2.25 2.25v3.25H5.25c-.413 0-.75-.337-.75-.75V3.25c0-.413.337-.75.75-.75h9.5c.413 0 .75.337.75.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dk7oT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M2.75 15c-.414 0-.75-.336-.75-.75v-10C2 3.01 3.01 2 4.25 2h10c.414 0 .75.336.75.75s-.336.75-.75.75h-10c-.414 0-.75.337-.75.75v10c0 .414-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.63 5H7.37C6.063 5 5 6.063 5 7.37v8.26C5 16.937 6.063 18 7.37 18h8.26c1.307 0 2.37-1.063 2.37-2.37V7.37C18 6.063 16.937 5 15.63 5m.87 10.63c0 .48-.39.87-.87.87H7.37c-.48 0-.87-.39-.87-.87V7.37c0-.48.39-.87.87-.87H11v4.134c0 .357.43.535.683.283l1.034-1.034c.156-.156.41-.156.566 0l1.034 1.034c.252.252.683.074.683-.283V6.5h.63c.48 0 .87.39.87.87z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aL1zM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.644 16.5H4.25c-.414 0-.75-.336-.75-.75V8.5h13v.144c0 .414.336.75.75.75s.75-.336.75-.75V5.25C18 4.01 16.99 3 15.75 3h-2V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-4.5V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-2C3.01 3 2 4.01 2 5.25v10.5C2 16.99 3.01 18 4.25 18h4.394c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M4.25 4.5h2V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h4.5V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h2c.414 0 .75.336.75.75V7h-13V5.25c0-.414.336-.75.75-.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 10.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.5 5.125h-1.875V17.5c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-1.875H12.5c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.875V12.5c0-.345.28-.625.625-.625s.625.28.625.625v1.875H17.5c.345 0 .625.28.625.625s-.28.625-.625.625"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bimOU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.25 15h-1.5C5.785 15 5 14.215 5 13.25v-1.5c0-.965.785-1.75 1.75-1.75h1.5c.965 0 1.75.785 1.75 1.75v1.5c0 .965-.785 1.75-1.75 1.75m-1.5-3.5c-.138 0-.25.112-.25.25v1.5c0 .138.112.25.25.25h1.5c.138 0 .25-.112.25-.25v-1.5c0-.138-.112-.25-.25-.25z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 3h-2V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-4.5V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-2C3.01 3 2 4.01 2 5.25v10.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V5.25C18 4.01 16.99 3 15.75 3M4.25 4.5h2V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h4.5V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h2c.413 0 .75.337.75.75V7h-13V5.25c0-.413.337-.75.75-.75m11.5 12H4.25c-.413 0-.75-.337-.75-.75V8.5h13v7.25c0 .413-.337.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5Rdp8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.562 10.068c-.966-.791-2.453-.688-3.38.24L11 14.49c-.248.248-.432.556-.533.89l-.954 3.16c-.08.266-.008.553.188.748.142.143.334.22.53.22q.108 0 .217-.033l3.158-.953c.336-.102.644-.286.89-.533l4.253-4.253c.494-.493.757-1.175.722-1.872-.034-.697-.366-1.351-.91-1.796m-5.389 7.018-1.82.549.55-1.821c.018-.058.059-.102.091-.152l1.332 1.332c-.05.033-.095.074-.153.092m4.515-4.41-3.456 3.456-1.376-1.376 3.388-3.388c.221-.221.512-.337.793-.337.21 0 .413.066.576.199.218.178.346.43.36.708s-.087.54-.285.738"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M7.894 16.521H4.25c-.413 0-.75-.337-.75-.75v-7.25h13.75c.414 0 .75-.336.75-.75v-2.5c0-1.24-1.01-2.25-2.25-2.25h-2v-1c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-4.5v-1c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-2C3.01 3.021 2 4.031 2 5.271v10.5c0 1.24 1.01 2.25 2.25 2.25h3.644c.414 0 .75-.336.75-.75s-.336-.75-.75-.75m-3.644-12h2v.5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h4.5v.5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h2c.414 0 .75.337.75.75v1.75h-13v-1.75c0-.413.337-.75.75-.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"827by":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.25 14.998h-6.5c-.965 0-1.75-.785-1.75-1.75v-1.5c0-.965.785-1.75 1.75-1.75h6.5c.965 0 1.75.785 1.75 1.75v1.5c0 .965-.785 1.75-1.75 1.75m-6.5-3.5c-.138 0-.25.112-.25.25v1.5c0 .138.112.25.25.25h6.5c.138 0 .25-.112.25-.25v-1.5c0-.138-.112-.25-.25-.25z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 3h-2V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-4.5V2c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-2C3.01 3 2 4.01 2 5.25v10.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V5.25C18 4.01 16.99 3 15.75 3M4.25 4.5h2V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h4.5V5c0 .414.336.75.75.75s.75-.336.75-.75v-.5h2c.413 0 .75.337.75.75v1.748h-13V5.25c0-.413.337-.75.75-.75m11.5 12H4.25c-.413 0-.75-.337-.75-.75V8.498h13v7.252c0 .413-.337.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8F2MX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.951 6.249h-1.286C15.267 3.399 12.878 1.2 9.992 1.2l-.01.002-.009-.002C7.087 1.2 4.7 3.4 4.3 6.25H3.05C1.919 6.249 1 7.168 1 8.298v3.645c0 1.12.911 2.04 2.034 2.05l1.71.007h.004c.044 0 .083-.018.126-.025.042.007.081.025.126.025h.002c.414-.001.749-.338.748-.752l-.015-6.163c0-2.418 1.901-4.385 4.238-4.385l.01-.002.009.002c2.337 0 4.237 1.967 4.237 4.385v6.665l.002.009c-.222.919-.954 1.72-2.01 2.219-.338-.583-.948-.978-1.65-.978H9.429c-1.063 0-1.928.897-1.928 2s.865 2 1.928 2h1.144c.89 0 1.636-.634 1.856-1.487 1.726-.672 2.949-1.955 3.284-3.484.002-.01-.001-.02 0-.031l1.257-.006c1.12-.009 2.031-.929 2.031-2.049V8.298c0-1.13-.919-2.049-2.049-2.049M2.5 11.943V8.298c0-.303.246-.549.549-.549h1.188l.011 4.749-1.205-.006c-.3-.002-.543-.249-.543-.549m8.072 5.557H9.428C9.192 17.5 9 17.275 9 17s.192-.5.428-.5h1.144c.236 0 .428.225.428.5s-.192.5-.428.5m6.928-5.557c0 .3-.244.547-.54.55l-1.23.005V7.749h1.221c.303 0 .549.246.549.549z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g2mMq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.687 12h-.75l-.005.001c-.31-.872-1.135-1.501-2.112-1.501s-1.801.629-2.112 1.5H9.312c-.414 0-.75.336-.75.75s.336.75.75.75h4.396c.31.871 1.135 1.5 2.112 1.5s1.802-.63 2.112-1.501l.005.001h.75c.414 0 .75-.336.75-.75s-.336-.75-.75-.75m-2.867 1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75.75.336.75.75-.337.75-.75.75M18.687 16.5h-4.396c-.31-.871-1.135-1.5-2.112-1.5s-1.802.63-2.112 1.501l-.005-.001h-.75c-.414 0-.75.336-.75.75s.336.75.75.75h.75l.005-.001c.31.872 1.135 1.501 2.112 1.501s1.801-.629 2.112-1.5h4.396c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M12.179 18c-.413 0-.75-.336-.75-.75s.337-.75.75-.75.75.336.75.75-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M7.144 16H3.25C2.01 16 1 14.99 1 13.75v-7.5C1 5.01 2.01 4 3.25 4h1.823c.286 0 .543-.159.67-.414l.172-.342C6.298 2.477 7.069 2 7.927 2h4.146c.858 0 1.63.477 2.012 1.244l.171.341c.128.256.385.415.671.415h1.823C17.99 4 19 5.01 19 6.25v2.713c0 .414-.336.75-.75.75s-.75-.336-.75-.75V6.25c0-.414-.336-.75-.75-.75h-1.823c-.858 0-1.63-.477-2.012-1.244l-.171-.341c-.128-.256-.385-.415-.671-.415H7.927c-.286 0-.543.159-.67.414l-.172.342C6.702 5.023 5.931 5.5 5.073 5.5H3.25c-.414 0-.75.336-.75.75v7.5c0 .414.336.75.75.75h3.894c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M7.117 11.75c-.27 0-.532-.147-.666-.403C6.156 10.78 6 10.142 6 9.5c0-2.206 1.794-4 4-4 1.99 0 3.694 1.485 3.963 3.455.057.41-.231.789-.641.845-.42.056-.79-.232-.845-.642C12.31 7.928 11.244 7 10 7 8.622 7 7.5 8.122 7.5 9.5c0 .407.095.795.281 1.153.192.368.05.82-.318 1.012-.111.058-.23.085-.346.085"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"M4C9q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.201 16.166c1.574-1.583 2.549-3.763 2.549-6.166 0-4.825-3.925-8.75-8.75-8.75-2.403 0-4.583.975-6.166 2.549q-.01.007-.021.014c-.011.007-.008.015-.014.021C2.225 5.417 1.25 7.597 1.25 10c0 4.825 3.925 8.75 8.75 8.75 2.403 0 4.583-.975 6.166-2.549.006-.006.015-.008.021-.014s.008-.015.014-.021M17.25 10c0 1.73-.61 3.317-1.625 4.565L5.435 4.375C6.683 3.36 8.271 2.75 10 2.75c3.998 0 7.25 3.252 7.25 7.25m-14.5 0c0-1.73.61-3.317 1.625-4.565l10.19 10.19C13.317 16.64 11.729 17.25 10 17.25c-3.998 0-7.25-3.252-7.25-7.25"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iIgvl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.18 8.664c-.712-.363-1.575-.098-1.972.586h-2.534c-.165-.81-.6-1.514-1.196-2.042l1.273-2.206c.28 0 .564-.076.816-.24.695-.45.892-1.38.44-2.074-.45-.695-1.38-.892-2.074-.44-.671.435-.872 1.315-.478 2l-1.276 2.21c-.373-.124-.765-.208-1.179-.208s-.806.084-1.179.208L7.548 4.252c.14-.242.215-.525.2-.826-.044-.827-.75-1.462-1.577-1.419s-1.462.75-1.419 1.577c.042.799.704 1.413 1.495 1.415l1.275 2.209C6.926 7.736 6.49 8.44 6.326 9.25h-2.53c-.14-.242-.347-.45-.615-.586-.738-.376-1.641-.083-2.017.655s-.083 1.641.655 2.017c.713.363 1.576.098 1.973-.586h2.534c.165.81.6 1.514 1.196 2.042l-1.273 2.206c-.28 0-.564.076-.816.24-.695.45-.892 1.38-.44 2.074s1.38.892 2.074.44c.671-.435.872-1.315.478-2l1.276-2.21c.373.124.765.208 1.179.208s.806-.084 1.179-.208l1.273 2.206c-.14.242-.215.525-.2.826.044.827.75 1.462 1.577 1.419s1.462-.75 1.419-1.576c-.042-.8-.704-1.414-1.495-1.416l-1.275-2.209c.596-.528 1.031-1.233 1.196-2.042h2.53c.14.242.347.45.615.586.738.376 1.641.083 2.017-.655s.083-1.641-.655-2.017m-6.476 2.788c-.328.385-.778.66-1.295.757-.133.024-.269.041-.409.041s-.276-.017-.41-.041c-.516-.096-.966-.372-1.294-.757-.176-.206-.315-.442-.408-.702-.084-.236-.138-.486-.138-.75s.054-.514.138-.75c.093-.26.232-.496.408-.702.328-.385.778-.66 1.295-.757.133-.024.269-.041.409-.041s.276.017.41.041c.516.096.966.372 1.294.757.176.206.315.442.408.702.084.236.138.486.138.75s-.054.514-.138.75c-.093.26-.232.496-.408.702"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2lNmz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.25 18H2.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h14.5c.414 0 .75.336.75.75s-.336.75-.75.75M6.75 15c-.414 0-.75-.336-.75-.75V10c0-.414.336-.75.75-.75s.75.336.75.75v4.25c0 .414-.336.75-.75.75M3.75 15c-.414 0-.75-.336-.75-.75v-2c0-.414.336-.75.75-.75s.75.336.75.75v2c0 .414-.336.75-.75.75M9.75 15c-.414 0-.75-.336-.75-.75V7.5c0-.414.336-.75.75-.75s.75.336.75.75v6.75c0 .414-.336.75-.75.75M12.75 15c-.414 0-.75-.336-.75-.75V5c0-.414.336-.75.75-.75s.75.336.75.75v9.25c0 .414-.336.75-.75.75M15.75 15c-.414 0-.75-.336-.75-.75V2.75c0-.414.336-.75.75-.75s.75.336.75.75v11.5c0 .414-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bDzGq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 1.25c-2.533 0-4.812 1.089-6.41 2.815-.019.016-.041.023-.058.041s-.022.042-.036.061C2.105 5.717 1.25 7.758 1.25 10c0 2.409.979 4.593 2.559 6.177l.005.009.009.005C5.407 17.771 7.591 18.75 10 18.75c4.825 0 8.75-3.925 8.75-8.75S14.825 1.25 10 1.25m-.75 7.052L5.184 4.596C6.29 3.609 7.695 2.949 9.25 2.789zM4.173 5.704l4.741 4.321-4.54 4.54C3.36 13.318 2.75 11.729 2.75 10c0-1.609.533-3.092 1.423-4.296M10 17.25c-1.73 0-3.318-.61-4.565-1.625l5.095-5.095q.006-.007.01-.015l.015-.01c.026-.029.036-.065.057-.096.027-.041.061-.077.08-.122l.006-.022c.018-.046.02-.094.028-.141.007-.042.024-.082.024-.124V2.789c3.647.376 6.5 3.466 6.5 7.211 0 3.998-3.252 7.25-7.25 7.25"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"c4s9O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M3 17.75c-.155 0-.312-.048-.445-.146-.334-.247-.405-.716-.159-1.05l2.298-3.113c.238-.322.69-.402 1.022-.176l2.05 1.379 1.621-6.985c.07-.299.314-.524.617-.571.304-.049.604.097.76.36l1.932 3.277 3.62-8.034c.17-.378.614-.545.992-.375s.546.615.376.993l-4.215 9.352c-.115.255-.363.425-.643.44-.276.03-.545-.126-.687-.368l-1.715-2.908-1.444 6.219c-.056.24-.226.437-.456.528-.23.09-.488.063-.693-.076L5.475 14.91l-1.871 2.535c-.147.2-.374.305-.604.305"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iaAWm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.75 2h-8C7.507 2 6.5 3.007 6.5 4.25v.5c0 .414.336.75.75.75S8 5.164 8 4.75v-.5c0-.413.337-.75.75-.75h8c.413 0 .75.338.75.75v4.5c0 .413-.337.75-.75.75H16c-.414 0-.75.336-.75.75v1.651L13.5 10.36V9.25C13.5 8.007 12.493 7 11.25 7h-8C2.007 7 1 8.007 1 9.25v4.5C1 14.99 2.01 16 3.25 16v2.137c0 .383.228.723.58.869q.182.073.365.072c.239 0 .466-.089.618-.245L8.033 16h3.217c1.243 0 2.25-1.007 2.25-2.25v-1.393l1.64 1.444c.18.18.42.275.665.275.122 0 .246-.023.364-.072.352-.147.581-.486.581-.867V11C17.99 11 19 9.99 19 8.75v-4.5C19 3.007 17.993 2 16.75 2M12 13.75c0 .413-.337.75-.75.75H7.467L4.75 16.894V15.25c0-.414-.336-.75-.75-.75h-.75c-.412 0-.75-.337-.75-.75v-4.5c0-.412.338-.75.75-.75h8c.413 0 .75.338.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"in5JG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.45 5.645c-.336-.247-.804-.171-1.049.162l-4.539 6.197L7.2 9.864c-.254-.327-.722-.386-1.053-.134-.327.255-.386.726-.132 1.053l2.273 2.927c.018.023.044.031.064.051.03.031.05.068.086.094.026.02.056.028.084.043q.034.02.071.037c.093.039.19.065.287.065h.002c.1 0 .2-.028.295-.07q.039-.016.075-.04c.03-.017.061-.026.089-.047.035-.028.055-.066.084-.098.019-.02.045-.03.061-.052l5.127-7c.244-.334.172-.803-.162-1.048"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.25 18H4.75C3.233 18 2 16.767 2 15.25V4.75C2 3.233 3.233 2 4.75 2h10.5C16.767 2 18 3.233 18 4.75v10.5c0 1.517-1.233 2.75-2.75 2.75M4.75 3.5c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25V4.75c0-.69-.56-1.25-1.25-1.25z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hmKpo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.862 16.455c-.196 0-.393-.077-.54-.23L3.835 10.52c-.28-.29-.28-.749 0-1.039l5.5-5.716c.287-.3.763-.308 1.06-.02.298.286.308.76.02 1.059l-4.999 5.197 4.986 5.184c.289.297.279.772-.02 1.06-.145.14-.332.21-.52.21"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.612 16.455c-.196 0-.393-.077-.54-.23L9.585 10.52c-.28-.29-.28-.749 0-1.039l5.5-5.716c.287-.3.763-.308 1.06-.02.298.286.308.76.02 1.059l-4.999 5.197 4.986 5.184c.289.297.279.772-.02 1.06-.145.14-.332.21-.52.21"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1TE6V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.618 16.245c-.299-.287-.309-.762-.02-1.06l4.986-5.183-5-5.197c-.287-.298-.277-.773.021-1.06.297-.287.773-.278 1.06.02l5.5 5.717c.28.29.28.75 0 1.04l-5.487 5.703c-.147.153-.344.23-.54.23-.188 0-.375-.07-.52-.21"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M3.868 16.245c-.299-.287-.309-.762-.02-1.06l4.986-5.183-5-5.197c-.287-.298-.277-.773.021-1.06.297-.287.773-.278 1.06.02l5.5 5.717c.28.29.28.75 0 1.04l-5.487 5.703c-.147.153-.344.23-.54.23-.188 0-.375-.07-.52-.21"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jSLkY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M3.545 12.237c0-.196.077-.393.23-.54L9.48 6.21c.29-.28.749-.28 1.039 0l5.716 5.5c.3.287.308.763.02 1.06-.286.298-.76.308-1.059.02L9.998 7.791l-5.184 4.986c-.297.288-.772.279-1.06-.02-.14-.145-.21-.332-.21-.52"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4exIF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kKJJv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13.22 12.657c-.13 0-.26-.033-.38-.103l-3.22-1.896c-.23-.135-.37-.38-.37-.646v-5c0-.414.336-.75.75-.75s.75.336.75.75v4.571l2.852 1.678c.356.21.475.67.265 1.027-.14.237-.39.37-.647.37m5.057.208c.18-.522.31-1.066.388-1.618.057-.41-.23-.789-.64-.847-.414-.058-.789.23-.846.64-.064.456-.171.905-.32 1.337-.134.392.074.818.465.953q.122.042.244.041c.312 0 .603-.195.71-.506m-.327-4.014c.404-.098.65-.503.552-.906-.13-.538-.314-1.066-.546-1.571-.173-.377-.622-.543-.995-.368-.376.173-.541.618-.368.995.191.417.344.854.452 1.298.083.344.39.573.727.573q.09 0 .178-.021M16.06 4.745c.285-.299.274-.774-.026-1.06-.398-.38-.838-.726-1.305-1.028-.351-.224-.814-.123-1.038.225-.223.348-.123.812.225 1.037.389.25.753.536 1.083.852.145.138.331.207.518.207.197 0 .395-.079.543-.233m-3.811-2.44c.078-.407-.188-.8-.595-.877-.54-.104-1.096-.157-1.653-.157h-.06c-.415 0-.72.336-.72.75s.366.75.78.75c.462 0 .923.044 1.37.13q.072.014.143.013c.352 0 .667-.25.735-.608m4.364 13.446c.272-.313.239-.786-.075-1.058-.311-.27-.785-.238-1.058.076-1.38 1.59-3.376 2.502-5.479 2.502-3.998 0-7.25-3.251-7.25-7.25 0-2.92 1.738-5.542 4.428-6.681.382-.161.56-.602.398-.983-.161-.381-.604-.561-.982-.398C3.348 3.332 1.25 6.497 1.25 10.021c0 4.826 3.925 8.75 8.75 8.75 2.538 0 4.948-1.1 6.612-3.02"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iihF3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.249 12.645c-.129 0-.26-.034-.379-.104l-3.22-1.895c-.23-.134-.37-.38-.37-.646V5c0-.414.335-.75.75-.75s.75.336.75.75v4.571l2.85 1.677c.357.21.476.67.266 1.026-.14.239-.39.37-.647.37"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jS6vK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.062 13.93c-.804.002-1.611-.229-2.27-.673-1.039-.702-1.61-1.852-1.61-3.237 0-1.78.888-2.718 1.634-3.193 1.21-.77 2.865-.794 3.764-.374.375.176.537.622.361.998-.175.374-.623.535-.997.361-.389-.183-1.5-.245-2.323.28-.623.397-.94 1.046-.94 1.928 0 .884.33 1.573.951 1.994.661.446 1.605.548 2.35.246.383-.154.821.032.976.416.155.385-.032.821-.416.976-.466.188-.972.279-1.48.279M7.894 13.93c-.805.002-1.612-.229-2.27-.674-1.04-.701-1.612-1.85-1.612-3.235 0-1.78.89-2.72 1.635-3.194 1.21-.771 2.864-.794 3.765-.374.375.176.537.622.361.998-.176.374-.623.535-.997.362-.39-.184-1.5-.246-2.324.28-.623.396-.94 1.045-.94 1.928s.33 1.572.951 1.993c.662.446 1.606.548 2.351.246.383-.154.82.032.976.416.154.385-.032.821-.416.976-.466.188-.973.279-1.48.279"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 17H3.25C2.01 17 1 15.99 1 14.75v-9.5C1 4.01 2.01 3 3.25 3h13.5C17.99 3 19 4.01 19 5.25v9.5c0 1.24-1.01 2.25-2.25 2.25M3.25 4.5c-.414 0-.75.337-.75.75v9.5c0 .413.336.75.75.75h13.5c.414 0 .75-.337.75-.75v-9.5c0-.413-.336-.75-.75-.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"k1FvW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m11.06 10 2.22-2.22c.293-.293.293-.767 0-1.06s-.767-.293-1.06 0L10 8.94 7.78 6.72c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06L8.94 10l-2.22 2.22c-.293.293-.293.767 0 1.06.146.147.338.22.53.22s.384-.073.53-.22L10 11.06l2.22 2.22c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"727hu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.25 16.998H3.718c-1.904 0-3.452-1.548-3.452-3.451 0-1.492.966-2.78 2.324-3.25q-.065-.348-.065-.703c0-2.18 1.81-3.952 4.034-3.952q.42 0 .83.087c.638-1.958 2.477-3.347 4.59-3.347 2.496 0 4.567 1.87 4.818 4.35.042.413-.259.78-.671.822-.4.05-.78-.258-.821-.671-.173-1.711-1.604-3.001-3.326-3.001-1.664 0-3.08 1.252-3.297 2.912-.032.235-.172.442-.38.558-.207.117-.458.125-.674.028-.349-.158-.71-.238-1.07-.238-1.396 0-2.533 1.1-2.533 2.452q.001.5.206.965c.1.223.083.482-.044.692s-.348.344-.593.36c-1.026.066-1.828.916-1.828 1.936 0 1.076.876 1.951 1.952 1.951H9.25c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.5 9.021c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.48-2.015 4.48-4.5-1.995-4.5-4.48-4.5m2.405 5.845c.293.293.293.768 0 1.06-.146.147-.338.22-.53.22s-.384-.073-.53-.22L15.5 14.583l-1.345 1.345c-.146.146-.338.22-.53.22s-.384-.074-.53-.22c-.293-.293-.293-.768 0-1.06l1.344-1.346-1.344-1.344c-.293-.293-.293-.768 0-1.06s.767-.294 1.06 0L15.5 12.46l1.345-1.345c.293-.293.767-.293 1.06 0s.293.768 0 1.06l-1.344 1.345z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2H4mr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.5 9.021c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.48-2.015 4.48-4.5-1.995-4.5-4.48-4.5m.95 6.895c0 .472-.425.855-.95.855s-.95-.383-.95-.855v-.289c0-.472.425-.856.95-.856s.95.384.95.856zm-.075-2.495c0 .414-.392.75-.875.75s-.875-.336-.875-.75v-2.65c0-.414.392-.75.875-.75s.875.336.875.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.25 16.998H3.718c-1.904 0-3.452-1.548-3.452-3.451 0-1.492.966-2.78 2.324-3.25q-.065-.348-.065-.703c0-2.18 1.81-3.952 4.034-3.952q.42 0 .83.087c.638-1.958 2.477-3.347 4.59-3.347 2.496 0 4.567 1.87 4.818 4.35.042.413-.259.78-.671.822-.4.05-.78-.258-.821-.671-.173-1.711-1.604-3.001-3.326-3.001-1.664 0-3.08 1.252-3.297 2.912-.032.235-.172.442-.38.558-.207.117-.458.125-.674.028-.349-.158-.71-.238-1.07-.238-1.396 0-2.533 1.1-2.533 2.452q.001.5.206.965c.1.223.083.482-.044.692s-.348.344-.593.36c-1.026.066-1.828.916-1.828 1.936 0 1.076.876 1.951 1.952 1.951H9.25c.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1X7NR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M7.8 17H3.718C1.814 17 .266 15.452.266 13.549c0-1.492.966-2.78 2.324-3.25q-.065-.348-.065-.703c0-2.18 1.81-3.952 4.034-3.952q.42 0 .83.087c.638-1.959 2.477-3.347 4.59-3.347 2.496 0 4.567 1.87 4.818 4.35.042.412-.259.78-.671.822-.405.048-.78-.26-.821-.671-.173-1.711-1.604-3.001-3.326-3.001-1.664 0-3.08 1.252-3.297 2.912-.032.235-.172.442-.38.558s-.457.125-.674.028c-.349-.158-.71-.238-1.07-.238-1.396 0-2.533 1.1-2.533 2.452q.001.5.206.965c.1.223.083.482-.044.692s-.348.344-.593.36c-1.026.066-1.828.916-1.828 1.936 0 1.076.876 1.951 1.952 1.951H7.8c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M19.362 9.892c-.328-.08-.673.125-.754.46l-.075.31c-.85-1.048-2.137-1.697-3.533-1.697-1.953 0-3.687 1.244-4.313 3.097-.132.392.078.818.47.95q.12.04.24.04c.313 0 .605-.197.71-.51.421-1.242 1.583-2.077 2.893-2.077.949 0 1.824.446 2.393 1.166l-.63-.152c-.33-.08-.672.125-.753.46s.125.673.46.754l2.093.506q.075.018.148.018c.281 0 .537-.193.606-.479l.506-2.092c.081-.335-.125-.673-.46-.754M18.84 14.036c-.393-.135-.818.076-.95.469-.421 1.24-1.582 2.072-2.89 2.072-.962 0-1.827-.445-2.392-1.166l.628.152c.332.082.673-.125.754-.46s-.125-.673-.46-.754l-2.093-.506c-.33-.08-.673.125-.754.46l-.03.12c-.014.05-.032.097-.035.15l-.441 1.823c-.081.335.125.673.46.754q.075.018.148.018c.281 0 .537-.192.607-.479l.075-.31c.843 1.05 2.117 1.698 3.533 1.698 1.95 0 3.682-1.242 4.31-3.09.133-.392-.077-.818-.47-.95"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3NngQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.25 17.002H3.718c-1.904 0-3.452-1.548-3.452-3.451 0-1.492.966-2.78 2.324-3.25q-.065-.348-.065-.703c0-2.18 1.81-3.952 4.034-3.952q.42 0 .83.087c.638-1.959 2.477-3.347 4.59-3.347 2.67 0 4.843 2.173 4.843 4.844q0 .464-.093.92c-.083.406-.479.67-.885.583-.407-.083-.667-.478-.584-.884q.061-.307.062-.619c0-1.844-1.5-3.344-3.343-3.344-1.664 0-3.08 1.252-3.297 2.912-.032.235-.172.442-.38.557-.207.118-.458.125-.674.029-.349-.158-.71-.238-1.07-.238-1.396 0-2.533 1.1-2.533 2.452q.001.5.206.965c.1.223.083.482-.044.692s-.348.344-.593.36c-1.026.066-1.828.916-1.828 1.936 0 1.076.876 1.951 1.952 1.951H9.25c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.503 13.434c-.192 0-.384-.074-.53-.22-.928-.929-2.161-1.44-3.472-1.442h-.006c-1.308 0-2.537.51-3.462 1.433-.293.293-.767.293-1.06 0s-.293-.768 0-1.06c1.208-1.208 2.813-1.873 4.522-1.873h.007c1.712.002 3.32.67 4.531 1.881.293.293.293.768 0 1.06-.146.147-.339.22-.53.22"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.384 15.544c-.193 0-.384-.073-.53-.22-.747-.745-1.96-.749-2.706-.004-.293.293-.767.293-1.06 0s-.293-.767 0-1.06c.643-.644 1.499-.998 2.41-.998h.003c.911 0 1.769.357 2.413 1.002.293.293.293.767 0 1.06-.146.147-.338.22-.53.22"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.136 17.64c-.35.351-.918.353-1.27.001s-.353-.922-.002-1.273.922-.351 1.274.001.35.92-.002 1.27"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2EIpu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.25 16.998H3.718c-1.904 0-3.452-1.548-3.452-3.451 0-1.492.966-2.78 2.324-3.25q-.065-.348-.065-.703c0-2.18 1.81-3.952 4.034-3.952q.42 0 .83.087c.638-1.958 2.477-3.347 4.59-3.347 2.496 0 4.567 1.87 4.818 4.35.042.413-.259.78-.671.822-.405.05-.78-.258-.821-.671-.173-1.711-1.604-3.001-3.326-3.001-1.664 0-3.08 1.252-3.297 2.912-.032.235-.172.442-.38.558-.207.117-.458.125-.674.028-.349-.158-.71-.238-1.07-.238-1.396 0-2.533 1.1-2.533 2.452q.001.5.206.965c.1.223.083.482-.044.692s-.348.344-.593.36c-1.026.066-1.828.916-1.828 1.936 0 1.076.876 1.951 1.952 1.951H9.25c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.5 9.021c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.48-2.015 4.48-4.5-1.995-4.5-4.48-4.5m-.5 6.375c0 .402-.325.727-.727.727s-.726-.325-.726-.727v-3.75c0-.4.325-.726.726-.726s.727.325.727.726zm2.453 0c0 .402-.325.727-.726.727S16 15.798 16 15.396v-3.75c0-.4.325-.726.727-.726s.726.325.726.726z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5MXoX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.235 14.646c-.093 0-.19-.022-.279-.066l-1.235-.616c-.212-.107-.346-.322-.346-.56V11.49c0-.344.28-.625.625-.625s.625.28.625.625v1.529l.89.443c.308.154.433.53.28.839-.11.219-.331.346-.56.346M18.98 14.583q-.04 0-.079-.004c-.412-.043-.712-.411-.669-.823q.011-.105.016-.211c.02-.413.36-.754.784-.714.413.02.734.37.714.784q-.007.147-.021.295c-.04.386-.366.673-.746.673"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 18.158c-2.62 0-4.75-2.13-4.75-4.75 0-1.913 1.139-3.63 2.901-4.376.378-.163.822.017.983.399.162.38-.017.821-.399.982-1.206.51-1.985 1.687-1.985 2.995 0 1.792 1.458 3.25 3.25 3.25.943 0 1.839-.408 2.457-1.12.272-.314.746-.347 1.058-.076s.346.745.075 1.058c-.902 1.04-2.211 1.638-3.59 1.638"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9 16.998H3.718c-1.904 0-3.452-1.548-3.452-3.451 0-1.492.966-2.78 2.324-3.25q-.065-.348-.065-.703c0-2.18 1.81-3.952 4.034-3.952q.42 0 .83.087c.638-1.958 2.477-3.347 4.59-3.347 2.496 0 4.567 1.87 4.818 4.35.042.413-.259.78-.671.822-.407.05-.78-.258-.821-.671-.173-1.711-1.604-3.001-3.326-3.001-1.664 0-3.08 1.252-3.297 2.912-.032.235-.172.442-.38.558s-.457.125-.674.028c-.349-.158-.71-.238-1.07-.238-1.396 0-2.533 1.1-2.533 2.452q.001.5.206.965c.1.223.083.482-.044.692s-.348.344-.593.36c-1.026.066-1.828.916-1.828 1.936 0 1.076.876 1.951 1.952 1.951H9c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.117 10.318q-.105 0-.21-.03-.098-.028-.199-.05c-.4-.09-.676-.49-.59-.893.085-.402.453-.663.86-.584.006 0 .055.011.063.013q.142.03.287.075c.398.116.625.533.509.93-.096.327-.395.54-.72.54M18.323 11.93c-.242 0-.48-.117-.625-.333q-.057-.085-.118-.165c-.252-.33-.19-.8.138-1.052.33-.252.8-.19 1.052.138q.093.12.176.247c.23.344.137.81-.208 1.04-.128.085-.272.126-.415.126"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eR09f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.946 16.998H3.718c-1.904 0-3.452-1.548-3.452-3.451 0-1.492.966-2.78 2.324-3.25q-.065-.348-.065-.703c0-2.18 1.81-3.952 4.034-3.952q.42 0 .83.087c.638-1.958 2.477-3.347 4.59-3.347 2.496 0 4.567 1.87 4.818 4.35.042.413-.259.78-.671.822-.403.047-.78-.258-.821-.671-.173-1.711-1.604-3.001-3.326-3.001-1.664 0-3.08 1.252-3.297 2.912-.032.235-.172.442-.38.558-.207.117-.457.125-.674.028-.349-.158-.71-.238-1.07-.238-1.396 0-2.533 1.1-2.533 2.452q.001.5.206.965c.1.223.083.482-.044.692s-.348.344-.593.36c-1.026.066-1.828.916-1.828 1.936 0 1.076.876 1.951 1.952 1.951h5.228c.414 0 .75.336.75.75s-.336.75-.75.75M19 16.271v-7c0-.414-.336-.75-.75-.75s-.75.336-.75.75v7c0 .415.336.75.75.75s.75-.335.75-.75M16 16.271v-5c0-.414-.336-.75-.75-.75s-.75.336-.75.75v5c0 .415.336.75.75.75s.75-.335.75-.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13 16.271v-3c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3c0 .415.336.75.75.75s.75-.335.75-.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1huEG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.407 17H3.717c-1.903 0-3.45-1.549-3.45-3.452 0-1.493.966-2.78 2.323-3.25q-.065-.346-.065-.702c0-2.18 1.81-3.953 4.034-3.953q.42 0 .831.087c.637-1.958 2.476-3.346 4.589-3.346 2.67 0 4.844 2.173 4.844 4.844q0 .659-.187 1.298c1.802.532 3.103 2.192 3.103 4.142 0 2.389-1.944 4.332-4.332 4.332M6.559 7.143c-1.397 0-2.534 1.1-2.534 2.453q.001.5.206.965c.1.223.083.482-.044.692s-.349.344-.593.36c-1.025.065-1.828.915-1.828 1.935 0 1.076.876 1.952 1.952 1.952h11.689c1.561 0 2.832-1.27 2.832-2.832 0-1.497-1.178-2.733-2.682-2.814-.255-.014-.485-.157-.611-.377-.127-.222-.132-.493-.014-.718.26-.5.39-1.015.39-1.531 0-1.844-1.5-3.344-3.344-3.344-1.662 0-3.08 1.252-3.297 2.912-.03.235-.172.442-.38.558-.207.117-.459.126-.674.027-.348-.158-.707-.238-1.068-.238"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8rpVg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M5.5 14.5c-.192 0-.384-.073-.53-.22l-3.75-3.75c-.293-.293-.293-.767 0-1.06l3.75-3.75c.293-.293.767-.293 1.06 0s.293.767 0 1.06L2.81 10l3.22 3.22c.293.293.293.767 0 1.06-.146.147-.338.22-.53.22M14.5 14.5c-.192 0-.384-.073-.53-.22-.293-.293-.293-.767 0-1.06L17.19 10l-3.22-3.22c-.293-.293-.293-.767 0-1.06s.767-.293 1.06 0l3.75 3.75c.293.293.293.767 0 1.06l-3.75 3.75c-.146.147-.338.22-.53.22M8.229 18q-.09 0-.177-.02c-.404-.098-.65-.503-.554-.906l3.5-14.5c.098-.403.51-.645.905-.553.404.097.65.502.554.905l-3.5 14.5c-.083.344-.39.574-.728.574"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aWHKw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.75 3H3.25C2.01 3 1 4.01 1 5.25v9.5C1 15.99 2.01 17 3.25 17h13.5c1.24 0 2.25-1.01 2.25-2.25v-9.5C19 4.01 17.99 3 16.75 3m.75 2.25v4h-4V4.5h3.25c.413 0 .75.337.75.75m-9.5 4V4.5h4v4.75zm4 1.5v4.75H8v-4.75zM3.25 4.5H6.5v4.75h-4v-4c0-.413.337-.75.75-.75M2.5 14.75v-4h4v4.75H3.25c-.413 0-.75-.337-.75-.75m14.25.75H13.5v-4.75h4v4c0 .413-.337.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jBc3C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.911 9.422c-.192 0-.384-.073-.53-.22L3.679 2.501c-.293-.293-.293-.768 0-1.06s.767-.294 1.06 0l6.702 6.7c.293.294.293.768 0 1.061-.146.147-.337.22-.53.22"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17.583 9.169c-.321-.394-.717-.764-1.087-1.059l-.003-.004-4.65-4.647c-.529-.53-1.286-.759-2.02-.618-.407.079-.673.472-.594.879.079.406.479.67.88.593.242-.05.496.029.674.207l4.65 4.648c.142.142.22.33.22.53s-.078.388-.22.53L9.432 16.23c-.293.293-.768.293-1.06 0l-4.65-4.648c-.293-.293-.293-.769 0-1.061l2.397-2.397c.293-.293.293-.768 0-1.06s-.767-.294-1.06 0L2.66 9.46c-.425.425-.659.99-.659 1.59 0 .602.234 1.168.66 1.593L7.31 17.29c.424.425.99.66 1.59.66s1.166-.235 1.591-.66l6.003-6.003c.176-.176.31-.38.417-.596.464 2.394-.724 3.437-.92 4.544-.128.789.408 1.532 1.197 1.66q.242.038.483-.004c.834-.077 1.39-.626 1.344-1.938s-.598-4.764-1.432-5.785"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8oMAI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 2H4.25C3.01 2 2 3.01 2 4.25v11.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V4.25C18 3.01 16.99 2 15.75 2m0 1.5c.413 0 .75.336.75.75v5h-5.75V3.5zM3.5 4.25c0-.414.337-.75.75-.75h5v5.75H3.5zm.75 12.25c-.413 0-.75-.336-.75-.75v-5h5.75v5.75zm12.25-.75c0 .414-.337.75-.75.75h-5v-5.75h5.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.069 3.114h6.959v6.698h-6.959z",
                opacity: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.069 10.114h6.959v6.698h-6.959z",
                opacity: 0.12
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M3.069 10.114h6.959v6.698H3.069z",
                opacity: 0.3
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fTKa2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10.859,
                cy: 5.521,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 6.859,
                cy: 7.521,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 6.859,
                cy: 12.521,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10.859,
                cy: 14.521,
                r: 1.5,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.003 18.771c-2.595-.018-4.935-.91-6.662-2.507-1.762-1.631-2.732-3.814-2.732-6.145s.97-4.514 2.732-6.144C6.192 2.257 8.683 1.27 11.17 1.27c2.157 0 4.143.737 5.594 2.074 1.048.97 1.626 2.27 1.626 3.659s-.578 2.69-1.625 3.66l-1.204 1.12c-.086.078-.188.206-.188.362s.102.284.188.364c.146.136.18.169.516.226.414.073.95.166 1.373.576l.001.001c.396.386.626.979.618 1.586-.008.59-.234 1.119-.636 1.49-1.625 1.513-3.97 2.382-6.431 2.382m.168-16c-2.114 0-4.233.84-5.81 2.304C3.907 6.42 3.108 8.211 3.108 10.12s.8 3.7 2.251 5.043c1.431 1.325 3.465 2.094 5.581 2.11 2.147 0 4.12-.723 5.473-1.983.133-.123.154-.31.156-.41.003-.223-.083-.41-.164-.49-.092-.088-.352-.134-.562-.17-.61-.106-.923-.254-1.306-.614-.428-.397-.664-.916-.664-1.46 0-.542.236-1.061.666-1.46l1.205-1.122c.74-.683 1.146-1.592 1.146-2.56s-.407-1.873-1.144-2.556c-1.172-1.08-2.797-1.675-4.576-1.675"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"14bSM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.369 11.696c-.212 0-.415-.09-.558-.248l-2.303-2.56c-.277-.308-.252-.782.056-1.059.307-.277.782-.252 1.06.056l1.685 1.874 3.152-4.299c.245-.334.714-.408 1.048-.161.334.244.407.714.162 1.048L9.974 11.39c-.134.182-.342.294-.568.305z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.25 19q-.151 0-.293-.06c-.277-.118-.457-.39-.457-.69V15h-.75C2.682 15 1 13.317 1 11.25v-5.5C1 3.683 2.682 2 4.75 2h10.5C17.318 2 19 3.683 19 5.75v5.5c0 2.067-1.682 3.75-3.75 3.75h-4.543L6.77 18.79c-.143.138-.33.21-.52.21M4.75 3.5C3.51 3.5 2.5 4.51 2.5 5.75v5.5c0 1.24 1.01 2.25 2.25 2.25h1.5c.414 0 .75.336.75.75v2.237l2.885-2.777c.14-.135.326-.21.52-.21h4.845c1.24 0 2.25-1.01 2.25-2.25v-5.5c0-1.24-1.01-2.25-2.25-2.25z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"llsW4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.294 16.661h-.044c-2.578-.15-5-2.459-5-3.767 0-.344.174-.705.549-1.134.272-.312.746-.345 1.058-.073.312.273.345.747.073 1.06q-.118.136-.163.209c.197.552 1.758 2.103 3.57 2.206.413.025.729.379.705.792-.022.399-.354.707-.748.707M18.279 15.169c.74-.625 1.471-1.504 1.471-2.275 0-1.311-2.43-3.98-5.26-3.98-.692.01-1.381.17-2.013.454l-.947-.947c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l7.299 7.3c.147.146.338.219.53.219s.384-.073.53-.22c.294-.293.294-.767 0-1.06zM14.5 10.414c2.049 0 3.67 2.004 3.751 2.457-.028.168-.383.696-1.043 1.227l-3.56-3.56c.28-.074.567-.12.852-.124"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.25 19q-.151 0-.293-.06c-.277-.118-.457-.39-.457-.69V15h-.75C2.682 15 1 13.317 1 11.25v-5.5C1 3.683 2.682 2 4.75 2h10.5C17.318 2 19 3.683 19 5.75v2.042c0 .414-.336.75-.75.75s-.75-.336-.75-.75V5.75c0-1.24-1.01-2.25-2.25-2.25H4.75C3.51 3.5 2.5 4.51 2.5 5.75v5.5c0 1.24 1.01 2.25 2.25 2.25h1.5c.414 0 .75.336.75.75v2.236l.895-.861c.298-.287.773-.277 1.06.02s.278.773-.02 1.06L6.77 18.79c-.142.138-.33.21-.52.21"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3G75z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.25 19q-.151 0-.294-.06c-.276-.118-.456-.39-.456-.69V15h-.75C2.683 15 1 13.317 1 11.25v-5.5C1 3.683 2.683 2 4.75 2h10.5C17.317 2 19 3.683 19 5.75v5.5c0 2.067-1.683 3.75-3.75 3.75h-4.543l-3.936 3.79c-.143.138-.33.21-.521.21M4.75 3.5C3.51 3.5 2.5 4.51 2.5 5.75v5.5c0 1.24 1.01 2.25 2.25 2.25h1.5c.414 0 .75.336.75.75v2.236l2.884-2.776c.14-.135.326-.21.52-.21h4.846c1.24 0 2.25-1.01 2.25-2.25v-5.5c0-1.24-1.01-2.25-2.25-2.25z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.5 9.5h-7c-.414 0-.75-.336-.75-.75S6.086 8 6.5 8h7c.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ihnDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.518 16.717c-2.665 0-5.268-2.389-5.268-3.775 0-1.15 1.594-2.734 3.026-3.438.685-.344 1.45-.531 2.215-.54 2.83 0 5.259 2.669 5.259 3.978 0 1.386-2.586 3.775-5.232 3.775m-.018-6.253c-.53.006-1.07.139-1.552.382q-.004 0-.008.004c-1.254.615-2.149 1.779-2.191 2.105.093.502 1.835 2.262 3.769 2.262 1.92 0 3.642-1.759 3.733-2.297-.081-.453-1.702-2.456-3.751-2.456m-1.89-.288h.01z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.431 12.354c.098.255.31.45.573.525.097.028.325.072.57-.03.304-.126.61.133.514.447-.098.32-.297.617-.604.842-.524.383-1.257.411-1.808.067-.902-.562-1.032-1.766-.348-2.506.17-.184.372-.318.589-.404.288-.115.607.17.505.463-.066.187-.068.396.01.596"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.25 19q-.151 0-.294-.06c-.276-.118-.456-.39-.456-.69V15h-.75C2.683 15 1 13.317 1 11.25v-5.5C1 3.683 2.683 2 4.75 2h10.5C17.317 2 19 3.683 19 5.75v2.042c0 .414-.336.75-.75.75s-.75-.336-.75-.75V5.75c0-1.24-1.01-2.25-2.25-2.25H4.75C3.51 3.5 2.5 4.51 2.5 5.75v5.5c0 1.24 1.01 2.25 2.25 2.25h1.5c.414 0 .75.336.75.75v2.236l.895-.861c.298-.287.773-.278 1.06.02s.278.773-.02 1.06L6.772 18.79c-.143.138-.33.21-.521.21"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fLdl8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M6.781 19q-.15 0-.293-.06c-.277-.118-.457-.39-.457-.69V15H4.75C2.682 15 1 13.317 1 11.25v-5.5C1 3.683 2.682 2 4.75 2h10.5C17.318 2 19 3.683 19 5.75v5.5c0 2.067-1.682 3.75-3.75 3.75h-4.012l-3.937 3.79c-.142.138-.33.21-.52.21M4.75 3.5C3.51 3.5 2.5 4.51 2.5 5.75v5.5c0 1.24 1.01 2.25 2.25 2.25h2.031c.414 0 .75.336.75.75v2.237l2.885-2.777c.14-.135.326-.21.52-.21h4.314c1.24 0 2.25-1.01 2.25-2.25v-5.5c0-1.24-1.01-2.25-2.25-2.25z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.25 10.5h-5.5c-.414 0-.75-.336-.75-.75S6.336 9 6.75 9h5.5c.414 0 .75.336.75.75s-.336.75-.75.75M13.25 7.5h-6.5c-.414 0-.75-.336-.75-.75S6.336 6 6.75 6h6.5c.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dRvKc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10.059 11.998c-2.09 0-3.788-1.784-3.788-3.977s1.699-3.979 3.788-3.979 3.788 1.785 3.788 3.979-1.7 3.977-3.788 3.977m0-6.456c-1.262 0-2.288 1.112-2.288 2.479s1.026 2.477 2.288 2.477 2.288-1.111 2.288-2.477-1.027-2.479-2.288-2.479M4.553 17.998q-.04.001-.081-.004c-.412-.045-.71-.415-.665-.827.276-2.546 2.963-4.467 6.252-4.467 3.264 0 6.011 1.966 6.253 4.476.04.413-.263.78-.675.818-.415.043-.778-.263-.818-.674-.166-1.72-2.301-3.12-4.76-3.12-2.48 0-4.571 1.374-4.761 3.13-.042.383-.367.668-.745.668M.75 15c-.137 0-.276-.037-.4-.115-.35-.22-.455-.685-.234-1.035.856-1.358 2.44-2.312 4.345-2.615.413-.07.794.213.859.622s-.214.794-.623.859c-1.457.232-2.695.955-3.313 1.934-.142.226-.386.35-.634.35M4.187 10q-.08 0-.16-.018c-1.748-.378-3.016-2.017-3.016-3.894 0-2.193 1.7-3.978 3.787-3.978.685 0 1.356.194 1.94.56.351.22.458.683.238 1.034-.22.35-.684.455-1.033.237-.346-.216-.742-.33-1.145-.33-1.26 0-2.287 1.11-2.287 2.477 0 1.177.771 2.198 1.834 2.43.405.087.662.487.574.891-.076.352-.387.591-.732.591M19.25 15c-.249 0-.492-.124-.634-.35-.618-.98-1.856-1.702-3.313-1.934-.41-.065-.688-.45-.623-.859s.45-.692.859-.622c1.905.303 3.49 1.257 4.345 2.615.221.35.116.814-.234 1.035-.124.078-.263.115-.4.115M15.813 10c-.345 0-.656-.24-.732-.59-.088-.405.169-.805.574-.892 1.063-.232 1.834-1.253 1.834-2.43 0-1.366-1.026-2.478-2.287-2.478-.403 0-.799.115-1.145.331-.349.218-.813.114-1.033-.237s-.113-.814.238-1.034c.584-.366 1.255-.56 1.94-.56 2.088 0 3.787 1.785 3.787 3.978 0 1.877-1.268 3.516-3.016 3.894q-.08.018-.16.018"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bB4qC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.25 18.021h-1c-1.24 0-2.25-1.01-2.25-2.25v-8.5c0-1.24 1.01-2.25 2.25-2.25h8.5c1.24 0 2.25 1.01 2.25 2.25v.979c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-.979c0-.413-.337-.75-.75-.75h-8.5c-.413 0-.75.337-.75.75v8.5c0 .414.337.75.75.75h1c.414 0 .75.336.75.75s-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M2.75 13.771c-.414 0-.75-.335-.75-.75v-8.75c0-1.24 1.01-2.25 2.25-2.25H13c.414 0 .75.336.75.75s-.336.75-.75.75H4.25c-.413 0-.75.337-.75.75v8.75c0 .415-.336.75-.75.75M19.43 18.37l-2.59-2.591c.469-.677.748-1.495.748-2.379 0-2.308-1.879-4.187-4.188-4.187S9.213 11.092 9.213 13.4s1.879 4.188 4.187 4.188c.884 0 1.702-.279 2.379-.749l2.591 2.592c.147.146.338.22.53.22s.384-.074.53-.22c.294-.293.294-.768 0-1.06m-8.717-4.97c0-1.481 1.206-2.687 2.687-2.687s2.688 1.206 2.688 2.687-1.206 2.688-2.688 2.688-2.687-1.206-2.687-2.688"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iAwMm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.75 12h-5.5C6.01 12 5 10.99 5 9.75v-4.5C5 4.01 6.01 3 7.25 3h5.5C13.99 3 15 4.01 15 5.25v4.5c0 1.24-1.01 2.25-2.25 2.25m-5.5-7.5c-.413 0-.75.337-.75.75v4.5c0 .413.337.75.75.75h5.5c.413 0 .75-.337.75-.75v-4.5c0-.413-.337-.75-.75-.75z",
                opacity: 0.35
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 19H3.25C2.01 19 1 17.99 1 16.75v-.5C1 15.01 2.01 14 3.25 14h13.5c1.24 0 2.25 1.01 2.25 2.25v.5c0 1.24-1.01 2.25-2.25 2.25m-13.5-3.5c-.413 0-.75.337-.75.75v.5c0 .413.337.75.75.75h13.5c.413 0 .75-.337.75-.75v-.5c0-.413-.337-.75-.75-.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"uJMHG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.25 14.25V12c0-.414-.336-.75-.75-.75s-.75.336-.75.75v2.25c0 1.24-1.01 2.25-2.25 2.25h-2.25c-.414 0-.75.336-.75.75s.336.75.75.75h2.25c2.068 0 3.75-1.682 3.75-3.75M18.25 8V5.75C18.25 3.682 16.568 2 14.5 2h-2.25c-.414 0-.75.336-.75.75s.336.75.75.75h2.25c1.24 0 2.25 1.01 2.25 2.25V8c0 .414.336.75.75.75s.75-.336.75-.75M3.75 8V5.75C3.75 4.51 4.76 3.5 6 3.5h2.25c.414 0 .75-.336.75-.75S8.664 2 8.25 2H6C3.932 2 2.25 3.682 2.25 5.75V8c0 .414.336.75.75.75s.75-.336.75-.75",
                opacity: 0.35
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.25 18H6c-2.068 0-3.75-1.682-3.75-3.75V12c0-.414.336-.75.75-.75s.75.336.75.75v2.25c0 1.24 1.01 2.25 2.25 2.25h2.25c.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5Tiyw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.25 14.25V12c0-.414-.336-.75-.75-.75s-.75.336-.75.75v2.25c0 1.24-1.01 2.25-2.25 2.25h-2.25c-.414 0-.75.336-.75.75s.336.75.75.75h2.25c2.068 0 3.75-1.682 3.75-3.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.25 8V5.75C18.25 3.682 16.568 2 14.5 2h-2.25c-.414 0-.75.336-.75.75s.336.75.75.75h2.25c1.24 0 2.25 1.01 2.25 2.25V8c0 .414.336.75.75.75s.75-.336.75-.75M3.75 8V5.75C3.75 4.51 4.76 3.5 6 3.5h2.25c.414 0 .75-.336.75-.75S8.664 2 8.25 2H6C3.932 2 2.25 3.682 2.25 5.75V8c0 .414.336.75.75.75s.75-.336.75-.75M8.25 18H6c-2.068 0-3.75-1.682-3.75-3.75V12c0-.414.336-.75.75-.75s.75.336.75.75v2.25c0 1.24 1.01 2.25 2.25 2.25h2.25c.414 0 .75.336.75.75s-.336.75-.75.75",
                opacity: 0.35
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jUoeK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18 14.25V12c0-.414-.336-.75-.75-.75s-.75.336-.75.75v2.25c0 1.24-1.01 2.25-2.25 2.25H12c-.414 0-.75.336-.75.75s.336.75.75.75h2.25c2.068 0 3.75-1.682 3.75-3.75M18 8V5.75C18 3.682 16.318 2 14.25 2H12c-.414 0-.75.336-.75.75s.336.75.75.75h2.25c1.24 0 2.25 1.01 2.25 2.25V8c0 .414.336.75.75.75S18 8.414 18 8M3.5 8V5.75c0-1.24 1.01-2.25 2.25-2.25H8c.414 0 .75-.336.75-.75S8.414 2 8 2H5.75C3.682 2 2 3.682 2 5.75V8c0 .414.336.75.75.75s.75-.336.75-.75M8 18H5.75C3.682 18 2 16.318 2 14.25V12c0-.414.336-.75.75-.75s.75.336.75.75v2.25c0 1.24 1.01 2.25 2.25 2.25H8c.414 0 .75.336.75.75S8.414 18 8 18"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8JlGs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.25 14.25V12c0-.414-.336-.75-.75-.75s-.75.336-.75.75v2.25c0 1.24-1.01 2.25-2.25 2.25h-2.25c-.414 0-.75.336-.75.75s.336.75.75.75h2.25c2.068 0 3.75-1.682 3.75-3.75M18.25 8V5.75C18.25 3.682 16.568 2 14.5 2h-2.25c-.414 0-.75.336-.75.75s.336.75.75.75h2.25c1.24 0 2.25 1.01 2.25 2.25V8c0 .414.336.75.75.75s.75-.336.75-.75",
                opacity: 0.35
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M3.75 8V5.75C3.75 4.51 4.76 3.5 6 3.5h2.25c.414 0 .75-.336.75-.75S8.664 2 8.25 2H6C3.932 2 2.25 3.682 2.25 5.75V8c0 .414.336.75.75.75s.75-.336.75-.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.25 18H6c-2.068 0-3.75-1.682-3.75-3.75V12c0-.414.336-.75.75-.75s.75.336.75.75v2.25c0 1.24 1.01 2.25 2.25 2.25h2.25c.414 0 .75.336.75.75s-.336.75-.75.75",
                opacity: 0.35
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eDnn5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.25 14.25V12c0-.414-.336-.75-.75-.75s-.75.336-.75.75v2.25c0 1.24-1.01 2.25-2.25 2.25h-2.25c-.414 0-.75.336-.75.75s.336.75.75.75h2.25c2.068 0 3.75-1.682 3.75-3.75",
                opacity: 0.35
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.25 8V5.75C18.25 3.682 16.568 2 14.5 2h-2.25c-.414 0-.75.336-.75.75s.336.75.75.75h2.25c1.24 0 2.25 1.01 2.25 2.25V8c0 .414.336.75.75.75s.75-.336.75-.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M3.75 8V5.75C3.75 4.51 4.76 3.5 6 3.5h2.25c.414 0 .75-.336.75-.75S8.664 2 8.25 2H6C3.932 2 2.25 3.682 2.25 5.75V8c0 .414.336.75.75.75s.75-.336.75-.75M8.25 18H6c-2.068 0-3.75-1.682-3.75-3.75V12c0-.414.336-.75.75-.75s.75.336.75.75v2.25c0 1.24 1.01 2.25 2.25 2.25h2.25c.414 0 .75.336.75.75s-.336.75-.75.75",
                opacity: 0.35
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lwOQJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M3.75 18c-.414 0-.75-.336-.75-.75v-5.5C3 6.925 6.925 3 11.75 3h5.5c.414 0 .75.336.75.75s-.336.75-.75.75h-5.5c-3.998 0-7.25 3.252-7.25 7.25v5.5c0 .414-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"901M5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.25 11.191c-.414 0-.75-.336-.75-.75V8.25c0-.413-.336-.75-.75-.75H9.513c-.414 0-.75-.336-.75-.75S9.1 6 9.513 6h2.237C12.99 6 14 7.01 14 8.25v2.191c0 .414-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.602 12.5H8.25c-.414 0-.75-.337-.75-.75V4.398c0-.414-.336-.75-.75-.75s-.75.336-.75.75V6H4.398c-.414 0-.75.336-.75.75s.336.75.75.75H6v4.25C6 12.99 7.01 14 8.25 14h4.25v1.623c0 .414.336.75.75.75s.75-.336.75-.75V14h1.602c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M14.665 2.25h-.032l.557-.558c.245-.244.245-.64 0-.884s-.64-.245-.883 0l-1.75 1.75c-.245.244-.245.64 0 .884l1.75 1.75c.122.122.281.183.442.183s.32-.06.441-.183c.245-.244.245-.64 0-.884l-.557-.558h.032c1.424 0 2.584 1.16 2.584 2.583 0 .414.335.75.75.75s.75-.336.75-.75c0-2.251-1.832-4.083-4.084-4.083M7.44 16.558l-1.75-1.75c-.245-.245-.64-.245-.884 0s-.244.64 0 .884l.557.558h-.032c-1.424 0-2.583-1.16-2.583-2.583 0-.414-.336-.75-.75-.75s-.75.336-.75.75c0 2.251 1.832 4.083 4.083 4.083h.032l-.557.558c-.244.244-.244.64 0 .884.122.122.281.183.442.183s.32-.06.441-.183l1.75-1.75c.245-.244.245-.64 0-.884"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bZPpG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.25 13.191c-.414 0-.75-.336-.75-.75V6.25c0-.413-.337-.75-.75-.75H7.513c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6.237C14.99 4 16 5.01 16 6.25v6.191c0 .414-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.602 14.5H6.25c-.413 0-.75-.337-.75-.75V1.398c0-.414-.336-.75-.75-.75S4 .984 4 1.398V4H1.398c-.414 0-.75.336-.75.75s.336.75.75.75H4v8.25C4 14.99 5.01 16 6.25 16h8.25v2.623c0 .414.336.75.75.75s.75-.336.75-.75V16h2.602c.414 0 .75-.336.75-.75s-.336-.75-.75-.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"01Om8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10.476 18.967q-.286 0-.559-.113C9.359 18.624 9 18.083 9 17.48V9.38c0-.6.358-1.14.913-1.372.554-.232 1.189-.11 1.616.31l5.524 5.42c.433.424.565 1.063.335 1.624s-.77.925-1.377.925h-2.28c-.217 0-.421.097-.56.265l-1.584 1.929c-.322.324-.717.487-1.111.487m.003-9.58.021 8.098 1.513-1.886c.423-.516 1.05-.813 1.718-.813h2.28zm.021-4.69V1.75c0-.414-.336-.75-.75-.75S9 1.336 9 1.75v2.946c0 .414.336.75.75.75s.75-.336.75-.75m7 4.053c0-.414-.336-.75-.75-.75h-2c-.414 0-.75.336-.75.75s.336.75.75.75h2c.414 0 .75-.336.75-.75m-10.91 0c0-.414-.336-.75-.75-.75H2.75c-.414 0-.75.336-.75.75s.336.75.75.75h3.09c.414 0 .75-.336.75-.75m6.598-2.378L15.23 4.33c.293-.293.293-.768 0-1.06s-.767-.293-1.06 0l-2.042 2.042c-.293.292-.293.767 0 1.06.146.147.338.22.53.22s.384-.073.53-.22M5.33 14.23l2.08-2.079c.292-.293.292-.767 0-1.06s-.768-.293-1.061 0l-2.08 2.079c-.292.293-.292.768 0 1.06.147.147.338.22.53.22s.385-.073.531-.22m2.155-7.745c.293-.293.293-.767 0-1.06L5.33 3.27c-.293-.293-.767-.293-1.06 0s-.293.767 0 1.06l2.155 2.155c.146.147.338.22.53.22s.384-.073.53-.22"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7TXs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 10.521c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.5 5.125h-1.875v1.875c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-1.875H12.5c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.875v-1.875c0-.344.28-.625.625-.625s.625.28.625.625v1.875H17.5c.345 0 .625.28.625.625s-.28.625-.625.625"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18 4c0-2.062-4.147-3-8-3s-8 .938-8 3v9.825c0 .027.013.05.015.077.161 1.621 2.849 2.572 5.376 2.922q.053.007.104.007c.369 0 .69-.271.742-.647.057-.41-.23-.788-.64-.846-2.814-.39-4.054-1.284-4.097-1.588v-3.344c1.341.742 3.373 1.185 5.247 1.304q.024.003.048.002c.392 0 .723-.305.748-.702.026-.413-.287-.77-.7-.796-3.008-.193-5.027-1.099-5.328-1.678q-.007-.009-.015-.019v-2.67C5.052 6.63 7.583 7 10 7s4.948-.37 6.5-1.154V7.75c0 .414.336.75.75.75s.75-.336.75-.75zm-8 1.5c-4.27 0-6.407-1.09-6.5-1.493v-.002C3.593 3.59 5.73 2.5 10 2.5c4.253 0 6.39 1.081 6.499 1.5-.109.419-2.246 1.5-6.499 1.5"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5i8F6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.592 15.186c-.398-.13-.818.086-.946.479-.447 1.367-1.711 2.285-3.146 2.285-1.074 0-2.04-.52-2.648-1.342l.16.058c.323.118.683-.05.8-.376.117-.324-.051-.683-.376-.8l-1.819-.656c-.158-.057-.334-.048-.485.026-.152.074-.268.205-.32.367l-.63 1.907c-.107.327.07.68.399.789q.097.031.195.031c.263 0 .507-.166.594-.43l.091-.275c.866 1.344 2.366 2.201 4.039 2.201 2.086 0 3.923-1.334 4.571-3.318.13-.395-.086-.818-.48-.946M19.318 11.054c-.326-.11-.68.071-.789.398l-.064.197c-.882-1.281-2.357-2.1-3.965-2.1-2.104 0-3.945 1.35-4.583 3.356-.125.396.093.818.487.943.4.13.818-.094.943-.488.438-1.381 1.706-2.31 3.153-2.31 1.07 0 2.05.528 2.663 1.36l-.274-.1c-.32-.115-.683.052-.8.377s.05.682.376.8l1.818.656q.104.037.212.037.143 0 .274-.064c.152-.073.267-.206.32-.366l.628-1.907c.107-.328-.07-.68-.399-.79"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.18 10.927C5.01 10.662 3.567 9.807 3.5 9.5V6.224C5.03 7.067 7.524 7.5 10 7.5s4.97-.433 6.5-1.276v1.5c0 .414.336.75.75.75s.75-.336.75-.75V4.56c0-.041-.017-.076-.023-.115.008-.066.023-.129.023-.196C18 2.116 13.976 1 10 1S2 2.116 2 4.25c0 .067.015.13.023.196C2.017 4.485 2 4.52 2 4.56V14.5c0 1.776 2.928 2.491 4.673 2.759q.058.009.115.009c.364 0 .684-.266.74-.636.063-.41-.217-.793-.627-.856-2.464-.379-3.356-1.072-3.401-1.276v-3.144c1.484.738 3.659.99 4.555 1.065l.063.003c.386 0 .714-.296.746-.688.035-.413-.271-.775-.684-.81M10 2.5c4.288 0 6.5 1.227 6.5 1.75S14.288 6 10 6 3.5 4.773 3.5 4.25 5.712 2.5 10 2.5"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cHrqP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m18.731 12.889-.69-.06q-.13-.276-.302-.53l.298-.624c.302-.634.064-1.406-.542-1.76l-.48-.28c-.608-.355-1.398-.18-1.8.394l-.396.566q-.15-.012-.304-.014c-.11-.01-.205.004-.306.012l-.391-.57c-.404-.587-1.175-.764-1.796-.41l-.482.276c-.61.348-.855 1.119-.558 1.754l.292.628q-.173.25-.306.526l-.69.055c-.7.053-1.25.646-1.254 1.348l-.002.557c-.003.702.541 1.3 1.24 1.361l.691.06q.131.277.301.529l-.297.624c-.303.634-.065 1.407.542 1.76l.48.281c.607.352 1.396.18 1.8-.394l.395-.567q.15.014.306.015c.096-.008.204-.004.305-.012l.391.57c.261.38.69.587 1.126.587.23 0 .46-.057.67-.177l.482-.276c.609-.348.854-1.118.558-1.755l-.292-.629q.173-.25.305-.524l.692-.055c.7-.055 1.25-.648 1.252-1.35l.003-.556c.003-.701-.542-1.299-1.24-1.36M18.72 14.8c0 .055-.045.103-.1.108l-1.07.084c-.246.02-.457.18-.54.412-.111.31-.276.593-.49.841-.16.187-.197.45-.093.672l.453.973c.024.051.005.113-.046.142l-.482.276c-.05.028-.113.013-.144-.034l-.608-.883c-.119-.171-.312-.27-.516-.27q-.054 0-.11.009-.233.043-.476.045c-.186-.013-.337-.019-.499-.05-.242-.043-.488.055-.629.256l-.615.878c-.032.047-.096.06-.145.032l-.48-.28c-.05-.029-.069-.091-.045-.142l.462-.968c.106-.222.072-.485-.087-.673-.211-.25-.374-.535-.482-.845-.081-.233-.29-.397-.536-.418l-1.07-.094c-.056-.005-.1-.053-.099-.11l.002-.557c0-.056.044-.102.101-.107l1.07-.085c.246-.02.457-.181.54-.412q.168-.469.49-.841c.16-.186.196-.45.092-.672l-.452-.974c-.025-.051-.005-.111.045-.14l.482-.276c.05-.027.113-.013.146.032l.607.885c.14.201.381.303.626.261q.232-.043.477-.045c.16.01.337.019.5.049.244.044.486-.055.626-.256l.616-.878c.032-.047.095-.061.145-.031l.48.28c.05.028.069.09.044.142l-.462.968c-.105.222-.071.485.087.672.212.251.375.536.483.846.08.232.29.395.535.417l1.07.095c.057.005.1.05.1.108z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.502 13.392c-.614-.002-1.113.493-1.116 1.106s.492 1.113 1.106 1.116 1.113-.492 1.116-1.106c.003-.613-.493-1.113-1.106-1.116M7.826 16.397c-3.103-.314-4.275-1.148-4.329-1.394v-3.147c1.245.622 2.96.897 3.924 1.006q.045.005.086.005c.376 0 .7-.282.744-.665.047-.412-.249-.783-.66-.83-2.935-.333-4.043-1.136-4.094-1.37V6.728c1.53.843 4.024 1.276 6.5 1.276s4.97-.433 6.5-1.276v.62c0 .414.336.75.75.75s.75-.336.75-.75V5.064c0-.04-.017-.076-.023-.115.008-.065.023-.129.023-.196 0-2.134-4.024-3.25-8-3.25s-8 1.116-8 3.25c0 .067.016.13.023.196-.006.04-.023.074-.023.115v9.939c0 2.145 4.346 2.752 5.678 2.887q.039.004.076.004c.38 0 .707-.289.746-.675.042-.412-.259-.78-.67-.822M9.997 3.003c4.289 0 6.5 1.226 6.5 1.75s-2.211 1.75-6.5 1.75-6.5-1.227-6.5-1.75 2.212-1.75 6.5-1.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l6Fye":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18 4.25C18 2.116 13.976 1 10 1S2 2.116 2 4.25c0 .067.015.13.023.196C2.017 4.485 2 4.52 2 4.56V14.5c0 1.795 2.981 2.507 4.758 2.772q.056.008.112.008c.365 0 .685-.267.74-.64.061-.409-.22-.79-.63-.852-2.522-.376-3.434-1.08-3.48-1.288v-3.155c.253.128.533.254.874.37q.122.043.243.042c.312 0 .603-.195.71-.507.134-.392-.075-.818-.466-.952C3.796 9.932 3.516 9.57 3.5 9.5V6.224C5.03 7.067 7.524 7.5 10 7.5s4.97-.433 6.5-1.276v3.27c-.018.081-.314.456-1.434.828-.393.131-.606.556-.476.948.105.315.398.514.712.514q.118 0 .237-.038c.379-.126.686-.262.961-.402v3.15c-.047.218-.975.932-3.545 1.304-.41.06-.694.44-.635.85.054.373.375.642.742.642q.053 0 .108-.008c1.804-.262 4.83-.97 4.83-2.782V4.56c0-.04-.017-.075-.023-.114.008-.066.023-.129.023-.196M10 6C5.711 6 3.5 4.773 3.5 4.25S5.711 2.5 10 2.5s6.5 1.227 6.5 1.75S14.289 6 10 6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.475 13.482c.192 0 .384-.073.53-.22.293-.292.293-.767 0-1.06L10.53 9.728c-.293-.293-.767-.293-1.06 0l-2.475 2.474c-.293.293-.293.768 0 1.06s.767.294 1.06 0l1.195-1.194v6.674c0 .414.336.75.75.75s.75-.336.75-.75v-6.674l1.195 1.195c.146.146.338.22.53.22"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"77KV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18 4.75c0-2.134-4.024-3.25-8-3.25S2 2.616 2 4.75c0 .067.015.13.023.196C2.017 4.985 2 5.02 2 5.06V15c0 2.062 4.147 3 8 3s8-.938 8-3V5.06c0-.04-.017-.075-.023-.114.008-.066.023-.129.023-.196m-1.5 5.245c-.092.415-2.228 1.505-6.5 1.505S3.59 10.41 3.5 10V6.724C5.03 7.567 7.524 8 10 8s4.97-.433 6.5-1.276zM10 3c4.289 0 6.5 1.227 6.5 1.75S14.289 6.5 10 6.5 3.5 5.273 3.5 4.75 5.711 3 10 3m0 13.5c-4.273 0-6.41-1.09-6.5-1.5v-3.154C5.052 12.63 7.583 13 10 13s4.948-.37 6.5-1.154v3.148c-.09.415-2.227 1.506-6.5 1.506"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4sR3H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M3.256 11.962H2.159C.97 11.962 0 11.049 0 9.927V2.035C0 .913.969 0 2.16 0h11.68C15.032 0 16 .913 16 2.035v.895c0 .414-.336.75-.75.75h-.001c-.414 0-.75-.336-.75-.75l.001-.895c0-.295-.296-.535-.66-.535H2.16c-.364 0-.66.24-.66.535v7.892c0 .295.296.535.66.535h1.096c.414 0 .75.336.75.75s-.336.75-.75.75m9.325 2.288c0-.414-.336-.75-.75-.75H7.75c-.414 0-.75-.337-.75-.75V9.5h9.75c.414 0 .75-.336.75-.75v-1.5C17.5 6.01 16.49 5 15.25 5h-7.5C6.51 5 5.5 6.01 5.5 7.25v5.5C5.5 13.99 6.51 15 7.75 15h4.08c.415 0 .75-.336.75-.75M7 7.25c0-.413.336-.75.75-.75h7.5c.414 0 .75.337.75.75V8H7zm13 11v-5.5c0-.965-.785-1.75-1.75-1.75h-2.5c-.965 0-1.75.785-1.75 1.75v5.5c0 .965.785 1.75 1.75 1.75h2.5c.965 0 1.75-.785 1.75-1.75m-1.75-5.75c.138 0 .25.112.25.25v5.5c0 .138-.112.25-.25.25h-2.5c-.138 0-.25-.112-.25-.25v-5.5c0-.138.112-.25.25-.25z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6ZTaF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M16.47 18h-4.94c-.843 0-1.53-.765-1.53-1.704V7.704C10 6.764 10.687 6 11.53 6h4.94c.843 0 1.53.765 1.53 1.704v8.592c0 .94-.687 1.704-1.53 1.704m-.043-10.51-4.897.01c.024.003-.03.078-.03.204v8.592c0 .126.054.201.073.214l4.897-.01c-.024-.003.03-.078.03-.204V7.704c0-.126-.054-.201-.073-.214"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                        cx: 14,
                        cy: 15.182,
                        rx: 0.619,
                        ry: 0.636
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M7.75 13H4.068C2.928 13 2 12.099 2 10.99V4.01C2 2.9 2.928 2 4.068 2H15.75C16.99 2 18 3.01 18 4.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75c0-.413-.337-.75-.75-.75H4.068c-.313 0-.568.229-.568.51v6.98c0 .281.255.51.568.51H7.75c.414 0 .75.336.75.75s-.336.75-.75.75M7.75 15.5h-1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.5c.414 0 .75.336.75.75s-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"auIka":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M19 17.5H1c-.414 0-.75-.336-.75-.75S.586 16 1 16h18c.414 0 .75.336.75.75s-.336.75-.75.75M15.75 15H4.25C3.01 15 2 13.99 2 12.75v-7.5C2 4.01 3.01 3 4.25 3h11.5C16.99 3 18 4.01 18 5.25v7.5c0 1.24-1.01 2.25-2.25 2.25M4.25 4.5c-.413 0-.75.337-.75.75v7.5c0 .413.337.75.75.75h11.5c.413 0 .75-.337.75-.75v-7.5c0-.413-.337-.75-.75-.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7DJon":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 5,
                cy: 8,
                r: 0.625,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8 14H4.25C3.01 14 2 12.99 2 11.75v-7.5C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75c0-.413-.337-.75-.75-.75H4.25c-.413 0-.75.337-.75.75v7.5c0 .413.337.75.75.75H8c.414 0 .75.336.75.75S8.414 14 8 14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.25 18h-4.5c-.965 0-1.75-.785-1.75-1.75v-8.5c0-.965.785-1.75 1.75-1.75h4.5c.965 0 1.75.785 1.75 1.75v8.5c0 .965-.785 1.75-1.75 1.75m-4.5-10.5c-.138 0-.25.112-.25.25v8.5c0 .138.112.25.25.25h4.5c.138 0 .25-.112.25-.25v-8.5c0-.138-.112-.25-.25-.25z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14,
                cy: 15,
                r: 0.625,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8DFUz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14 18.5H9c-.414 0-.75-.336-.75-.75S8.586 17 9 17h5c.414 0 .75.336.75.75s-.336.75-.75.75M16.75 16H6.25C5.01 16 4 14.99 4 13.75v-5.5C4 7.01 5.01 6 6.25 6h10.5C17.99 6 19 7.01 19 8.25v5.5c0 1.24-1.01 2.25-2.25 2.25M6.25 7.5c-.414 0-.75.337-.75.75v5.5c0 .413.336.75.75.75h10.5c.413 0 .75-.337.75-.75v-5.5c0-.413-.337-.75-.75-.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M1.75 10.5c-.414 0-.75-.336-.75-.75v-6.5C1 2.01 2.01 1 3.25 1h10.5C14.99 1 16 2.01 16 3.25v.492c0 .414-.336.75-.75.75s-.75-.336-.75-.75V3.25c0-.413-.337-.75-.75-.75H3.25c-.414 0-.75.337-.75.75v6.5c0 .414-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6988a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 15,
                r: 1,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.75 19h-7.5C5.01 19 4 17.99 4 16.75V3.25C4 2.01 5.01 1 6.25 1h7.5C14.99 1 16 2.01 16 3.25v13.5c0 1.24-1.01 2.25-2.25 2.25M6.25 2.5c-.413 0-.75.337-.75.75v13.5c0 .413.337.75.75.75h7.5c.413 0 .75-.337.75-.75V3.25c0-.413-.337-.75-.75-.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2qhE3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M8.75 9.49c0-1.317.895-2.417 2.106-2.758-.012-.388-.097-.768-.256-1.115l3.038-2.569c.014.005.026.014.04.018.788.257 1.634-.173 1.891-.96S15.396.47 14.61.214q-.236-.075-.47-.074c-.63.002-1.215.404-1.422 1.035-.079.243-.086.49-.044.725l-3.04 2.57c-.222-.154-.46-.289-.731-.377-1.496-.488-3.105.329-3.594 1.825-.234.718-.161 1.46.137 2.094l-3.236 2.737-.013-.006c-.788-.257-1.635.173-1.892.96-.055.17-.079.344-.074.513.02.613.417 1.178 1.035 1.38.787.256 1.634-.174 1.891-.961.083-.254.088-.511.04-.756l3.228-2.73c.216.147.448.277.71.362.543.178 1.101.179 1.616.041zM11.626 18.955c-.209 0-.419-.04-.62-.123-.611-.251-1.006-.841-1.006-1.502V9.65c0-.659.393-1.248 1.001-1.5.609-.253 1.302-.116 1.77.35l5.25 5.234c.467.466.606 1.161.354 1.771s-.84 1.004-1.501 1.004h-2.098l-1.998 1.964c-.312.315-.728.482-1.152.482m.003-9.431q-.022 0-.052.011c-.077.032-.077.093-.077.115v7.68c0 .023 0 .083.077.115.078.033.12-.011.135-.027l1.91-1.928c.303-.306.724-.49 1.154-.49h2.098c.023 0 .083.009.115-.068s-.01-.119-.027-.135l-5.25-5.235c-.012-.012-.039-.038-.083-.038"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6D32N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m14.292 13.501-2.121-5.304-.004-.006c-.024-.058-.063-.109-.104-.157-.011-.014-.018-.033-.03-.045-.02-.02-.048-.031-.07-.048-.044-.033-.085-.067-.134-.087l-.006-.004-5.302-2.121c-.233-.094-.498-.04-.675.137s-.23.443-.138.675l2.121 5.304q.001.002.004.004c.041.101.115.184.204.252.023.017.043.03.068.044.025.015.044.036.072.047l5.302 2.121q.115.045.233.045c.162 0 .322-.063.442-.182.177-.177.23-.443.138-.675m-5.402-2.37 2.22-2.22 1.48 3.7z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jyhIC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.25 16.5h-2.388c.084-.236.138-.486.138-.75v-1.5c0-1.24-1.01-2.25-2.25-2.25h-7.5C5.01 12 4 13.01 4 14.25v1.5c0 .264.054.514.138.75H1.75c-.414 0-.75.336-.75.75s.336.75.75.75h16.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75m-12 0c-.413 0-.75-.337-.75-.75v-1.5c0-.413.337-.75.75-.75h7.5c.413 0 .75.337.75.75v1.5c0 .413-.337.75-.75.75zM18.25 7.5h-4.388c.084-.236.138-.486.138-.75v-1.5C14 4.01 12.99 3 11.75 3h-3.5C7.01 3 6 4.01 6 5.25v1.5c0 .264.054.514.138.75H1.75c-.414 0-.75.336-.75.75s.336.75.75.75h16.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75m-10 0c-.413 0-.75-.337-.75-.75v-1.5c0-.413.337-.75.75-.75h3.5c.413 0 .75.337.75.75v1.5c0 .413-.337.75-.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bFGRm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M14.75 6V1.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75V6C12.01 6 11 7.01 11 8.25v3.5c0 1.24 1.01 2.25 2.25 2.25v4.25c0 .414.336.75.75.75s.75-.336.75-.75V14c1.24 0 2.25-1.01 2.25-2.25v-3.5C17 7.01 15.99 6 14.75 6m.75 5.75c0 .413-.337.75-.75.75h-1.5c-.413 0-.75-.337-.75-.75v-3.5c0-.413.337-.75.75-.75h1.5c.413 0 .75.337.75.75zM6.75 4V1.75C6.75 1.336 6.414 1 6 1s-.75.336-.75.75V4C4.01 4 3 5.01 3 6.25v7.5C3 14.99 4.01 16 5.25 16v2.25c0 .414.336.75.75.75s.75-.336.75-.75V16C7.99 16 9 14.99 9 13.75v-7.5C9 5.01 7.99 4 6.75 4m.75 9.75c0 .413-.337.75-.75.75h-1.5c-.413 0-.75-.337-.75-.75v-7.5c0-.413.337-.75.75-.75h1.5c.413 0 .75.337.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iq2rD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M5.75 4h-1.5c-.264 0-.514.054-.75.138V1.75c0-.414-.336-.75-.75-.75S2 1.336 2 1.75v16.5c0 .414.336.75.75.75s.75-.336.75-.75v-2.388c.236.084.486.138.75.138h1.5C6.99 16 8 14.99 8 13.75v-7.5C8 5.01 6.99 4 5.75 4m.75 9.75c0 .413-.337.75-.75.75h-1.5c-.413 0-.75-.337-.75-.75v-7.5c0-.413.337-.75.75-.75h1.5c.413 0 .75.337.75.75zM14.75 6h-1.5c-.264 0-.514.054-.75.138V1.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75v16.5c0 .414.336.75.75.75s.75-.336.75-.75v-4.388c.236.084.486.138.75.138h1.5c1.24 0 2.25-1.01 2.25-2.25v-3.5C17 7.01 15.99 6 14.75 6m.75 5.75c0 .413-.337.75-.75.75h-1.5c-.413 0-.75-.337-.75-.75v-3.5c0-.413.337-.75.75-.75h1.5c.413 0 .75.337.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aXPzo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.25 1c-.414 0-.75.336-.75.75v4.388c-.236-.084-.486-.138-.75-.138h-1.5C13.01 6 12 7.01 12 8.25v3.5c0 1.24 1.01 2.25 2.25 2.25h1.5c.264 0 .514-.054.75-.138v4.388c0 .414.336.75.75.75s.75-.336.75-.75V1.75c0-.414-.336-.75-.75-.75m-1.5 11.5h-1.5c-.413 0-.75-.337-.75-.75v-3.5c0-.413.337-.75.75-.75h1.5c.413 0 .75.337.75.75v3.5c0 .413-.337.75-.75.75M8.25 1c-.414 0-.75.336-.75.75v2.388C7.264 4.054 7.014 4 6.75 4h-1.5C4.01 4 3 5.01 3 6.25v7.5C3 14.99 4.01 16 5.25 16h1.5c.264 0 .514-.054.75-.138v2.388c0 .414.336.75.75.75s.75-.336.75-.75V1.75C9 1.336 8.664 1 8.25 1m-1.5 13.5h-1.5c-.413 0-.75-.337-.75-.75v-7.5c0-.413.337-.75.75-.75h1.5c.413 0 .75.337.75.75v7.5c0 .413-.337.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1PyrC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10.75 15h-1.5C8.01 15 7 13.99 7 12.75v-5.5C7 6.01 8.01 5 9.25 5h1.5C11.99 5 13 6.01 13 7.25v5.5c0 1.24-1.01 2.25-2.25 2.25m-1.5-8.5c-.413 0-.75.337-.75.75v5.5c0 .413.337.75.75.75h1.5c.413 0 .75-.337.75-.75v-5.5c0-.413-.337-.75-.75-.75zM16.25 18c-.414 0-.75-.336-.75-.75V2.75c0-.414.336-.75.75-.75s.75.336.75.75v14.5c0 .414-.336.75-.75.75M3.75 18c-.414 0-.75-.336-.75-.75V2.75c0-.414.336-.75.75-.75s.75.336.75.75v14.5c0 .414-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fk1ac":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15 9.25v1.5c0 1.24-1.01 2.25-2.25 2.25h-5.5C6.01 13 5 11.99 5 10.75v-1.5C5 8.01 6.01 7 7.25 7h5.5C13.99 7 15 8.01 15 9.25m-8.5 1.5c0 .413.337.75.75.75h5.5c.413 0 .75-.337.75-.75v-1.5c0-.413-.337-.75-.75-.75h-5.5c-.413 0-.75.337-.75.75zM18 3.75c0 .414-.336.75-.75.75H2.75c-.414 0-.75-.336-.75-.75S2.336 3 2.75 3h14.5c.414 0 .75.336.75.75M18 16.25c0 .414-.336.75-.75.75H2.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h14.5c.414 0 .75.336.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hHUco":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.25 2H1.75c-.414 0-.75.336-.75.75s.336.75.75.75h4.388c-.084.236-.138.486-.138.75v1.5C6 6.99 7.01 8 8.25 8h3.5C12.99 8 14 6.99 14 5.75v-1.5c0-.264-.054-.514-.138-.75h4.388c.414 0 .75-.336.75-.75S18.664 2 18.25 2M12.5 4.25v1.5c0 .413-.337.75-.75.75h-3.5c-.413 0-.75-.337-.75-.75v-1.5c0-.413.337-.75.75-.75h3.5c.413 0 .75.337.75.75M18.25 11H1.75c-.414 0-.75.336-.75.75s.336.75.75.75h2.388c-.084.236-.138.486-.138.75v1.5C4 15.99 5.01 17 6.25 17h7.5c1.24 0 2.25-1.01 2.25-2.25v-1.5c0-.264-.054-.514-.138-.75h2.388c.414 0 .75-.336.75-.75s-.336-.75-.75-.75m-3.75 2.25v1.5c0 .413-.337.75-.75.75h-7.5c-.413 0-.75-.337-.75-.75v-1.5c0-.413.337-.75.75-.75h7.5c.413 0 .75.337.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"KLXIn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.25 5.25H14C14 4.01 12.99 3 11.75 3h-3.5C7.01 3 6 4.01 6 5.25H1.75c-.414 0-.75.336-.75.75s.336.75.75.75H6C6 7.99 7.01 9 8.25 9h3.5C12.99 9 14 7.99 14 6.75h4.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75m-5.75 1.5c0 .413-.337.75-.75.75h-3.5c-.413 0-.75-.337-.75-.75v-1.5c0-.413.337-.75.75-.75h3.5c.413 0 .75.337.75.75zM18.25 13.25H16c0-1.24-1.01-2.25-2.25-2.25h-7.5C5.01 11 4 12.01 4 13.25H1.75c-.414 0-.75.336-.75.75s.336.75.75.75H4C4 15.99 5.01 17 6.25 17h7.5c1.24 0 2.25-1.01 2.25-2.25h2.25c.414 0 .75-.336.75-.75s-.336-.75-.75-.75m-3.75 1.5c0 .413-.337.75-.75.75h-7.5c-.413 0-.75-.337-.75-.75v-1.5c0-.413.337-.75.75-.75h7.5c.413 0 .75.337.75.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fSeMY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.53 1.999c-1.27-1.042-3.225-.9-4.449.324L3.105 12.3c-.319.317-.557.716-.689 1.15l-1.384 4.584c-.08.265-.008.552.188.747.142.143.334.22.53.22q.11 0 .217-.032l4.585-1.384c.433-.132.832-.37 1.148-.688L17.777 6.818c.649-.647.994-1.544.949-2.46S18.244 2.583 17.53 2M7.468 15.006l-2.48-2.47 6.858-6.857 2.475 2.475zm-4.596 2.122.98-3.244c.026-.09.066-.173.11-.252l2.413 2.402q-.122.072-.258.114zm13.845-11.37L15.38 7.093 12.907 4.62l1.235-1.235c.386-.387.896-.586 1.39-.586.38 0 .751.118 1.049.361.392.321.621.774.647 1.274.024.493-.163.976-.511 1.325"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bHSBe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.75 2.75c0-.414-.336-.75-.75-.75H4.25C3.01 2 2 3.01 2 4.25V13c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-.414.336-.75.75-.75H13c.414 0 .75-.336.75-.75M14.75 11.5c0 .414-.336.75-.75.75h-1.75V14c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.75H9c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1.75V9c0-.414.336-.75.75-.75s.75.336.75.75v1.75H14c.414 0 .75.336.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 5h-8.5C6.01 5 5 6.01 5 7.25v8.5C5 16.99 6.01 18 7.25 18h8.5c1.24 0 2.25-1.01 2.25-2.25v-8.5C18 6.01 16.99 5 15.75 5m.75 10.75c0 .414-.336.75-.75.75h-8.5c-.414 0-.75-.336-.75-.75v-8.5c0-.414.336-.75.75-.75h8.5c.414 0 .75.336.75.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lB02x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.25 19.023c-.192 0-.384-.073-.53-.22l-16.5-16.5c-.293-.292-.293-.767 0-1.06s.767-.293 1.06 0l16.5 16.5c.293.293.293.768 0 1.06-.146.147-.338.22-.53.22M14.398 10.207l-1.06-1.06 3.652-3.654c.349-.348.535-.83.511-1.324-.025-.5-.255-.952-.647-1.273-.684-.56-1.754-.461-2.439.223l-3.552 3.552c-.293.293-.767.293-1.06 0s-.293-.768 0-1.06l3.551-3.552c1.223-1.224 3.18-1.366 4.45-.324.714.584 1.15 1.444 1.195 2.36s-.3 1.811-.948 2.459zM10.339 13.206c-.293-.293-.768-.293-1.06 0L7.44 15.043l-2.475-2.475 1.794-1.794c.293-.293.293-.767 0-1.06s-.768-.293-1.06 0l-2.624 2.623c-.32.318-.556.716-.687 1.15L1.004 18.07c-.08.265-.008.552.187.747.143.143.334.22.53.22q.11 0 .217-.032l4.584-1.384c.433-.13.83-.368 1.15-.688l2.667-2.666c.293-.293.293-.768 0-1.061m-7.494 3.959.98-3.245q.042-.135.113-.258l2.41 2.409q-.123.07-.258.114z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bf5nW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 11.622c-.287 0-.574-.055-.847-.165l-.956-.386c-.384-.154-.57-.592-.416-.975.156-.384.591-.573.976-.415l.957.385c.184.075.387.075.57 0l7.058-2.844c.13-.053.158-.156.158-.233 0-.076-.027-.177-.158-.23l-7.057-2.846c-.184-.073-.388-.072-.572.001L2.658 6.76c-.13.053-.158.155-.158.231s.027.179.158.232l.3.12c.384.155.57.593.415.976-.155.384-.593.57-.976.415l-.3-.12C1.43 8.342 1 7.705 1 6.988s.431-1.353 1.097-1.62l7.057-2.847c.546-.218 1.146-.22 1.69 0l7.059 2.846C18.569 5.636 19 6.272 19 6.99s-.43 1.354-1.097 1.623l-7.057 2.845c-.273.11-.56.165-.846.165M9.962 15.933c-.582 0-1.157-.051-1.71-.15-.408-.075-.678-.465-.605-.873s.468-.675.872-.604c.465.084.95.127 1.443.127 3.967 0 5.25-1.762 5.25-2.616 0-.414.336-.75.75-.75s.75.336.75.75c0 1.145-1.212 4.116-6.75 4.116"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.695 6.423c-.158-.382-.596-.562-.98-.406L6.102 7.514c-.845.348-1.39 1.165-1.39 2.079v5.964l-.482.964c-.213.426-.191.924.06 1.33s.686.649 1.164.649.912-.242 1.163-.648c.252-.407.274-.905.06-1.331l-.465-.931V9.593c0-.305.182-.576.463-.693l3.614-1.497c.383-.159.565-.597.406-.98"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"RFzUR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 2.75H4.25c-.828 0-1.5.672-1.5 1.5v11.5c0 .828.672 1.5 1.5 1.5h11.5c.828 0 1.5-.672 1.5-1.5V4.25c0-.828-.672-1.5-1.5-1.5m-1.5 10.5c0 .552-.448 1-1 1h-6.5c-.552 0-1-.448-1-1v-6.5c0-.552.448-1 1-1h6.5c.552 0 1 .448 1 1z",
                opacity: 0.12
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.25 15h-6.5C5.785 15 5 14.215 5 13.25v-6.5C5 5.785 5.785 5 6.75 5h6.5c.965 0 1.75.785 1.75 1.75v6.5c0 .965-.785 1.75-1.75 1.75m-6.5-8.5c-.138 0-.25.112-.25.25v6.5c0 .138.112.25.25.25h6.5c.138 0 .25-.112.25-.25v-6.5c0-.138-.112-.25-.25-.25z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15.75 18H4.25C3.01 18 2 16.99 2 15.75V4.25C2 3.01 3.01 2 4.25 2h11.5C16.99 2 18 3.01 18 4.25v11.5c0 1.24-1.01 2.25-2.25 2.25M4.25 3.5c-.413 0-.75.337-.75.75v11.5c0 .413.337.75.75.75h11.5c.413 0 .75-.337.75-.75V4.25c0-.413-.337-.75-.75-.75z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jyYA8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.809 7.22c-.294-.294-.769-.292-1.061 0l-3.003 3.004-1.558-2.835c-.132-.24-.384-.389-.658-.389H7.474l.569-1.845c.003-.017.364-1.712 1.505-2.382.547-.32 1.193-.357 1.973-.11.397.122.817-.097.942-.49.124-.396-.096-.817-.49-.942-1.197-.375-2.272-.29-3.194.254-1.717 1.016-2.187 3.278-2.188 3.3L5.907 7H3.715c-.414 0-.75.336-.75.75s.336.75.75.75h1.73l-2.94 9.53c-.122.395.1.815.496.937q.11.033.22.033c.321 0 .618-.207.717-.53L7.012 8.5h4.074l1.554 2.83-3.39 3.39c-.292.293-.292.767 0 1.06.147.147.34.22.531.22.193 0 .384-.073.53-.22l3.082-3.082 1.6 2.913c.137.248.394.389.658.389.122 0 .246-.03.36-.093.364-.199.496-.655.297-1.018l-1.811-3.296 3.312-3.313c.293-.293.293-.767 0-1.06"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a0yC6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.75 2.993H3.25C2.01 2.993 1 4.003 1 5.243v9.5c0 1.24 1.01 2.25 2.25 2.25h13.5c1.24 0 2.25-1.01 2.25-2.25v-9.5c0-1.24-1.01-2.25-2.25-2.25m-.42 1.5-5.838 5.083c-.28.244-.704.244-.985 0L3.67 4.493zm.42 11H3.25c-.413 0-.75-.337-.75-.75V5.462l6.021 5.245c.422.367.95.55 1.479.55s1.057-.183 1.478-.55L17.5 5.462v9.281c0 .413-.337.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cHQyX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 14.5c-1.927 0-3.283-1.13-3.34-1.178-.316-.267-.355-.74-.087-1.057.267-.315.74-.356 1.056-.087.008.006 1.009.822 2.371.822 1.371 0 2.417-.825 2.428-.833.322-.258.794-.209 1.053.113.26.32.212.79-.107 1.051-.06.048-1.455 1.169-3.374 1.169"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 7.25,
                cy: 8,
                r: 1.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 12.75,
                cy: 8,
                r: 1.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.978 14.5c-1.927 0-3.283-1.13-3.34-1.178-.316-.267-.355-.74-.087-1.056.267-.318.74-.356 1.056-.088.008.006 1.009.822 2.37.822 1.372 0 2.418-.825 2.428-.833.323-.259.794-.208 1.054.112.26.322.212.791-.108 1.052-.059.048-1.455 1.169-3.373 1.169"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 7.25,
                cy: 8.023,
                r: 1.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 12.75,
                cy: 8.023,
                r: 1.25,
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 18.75c-4.825 0-8.75-3.925-8.75-8.75S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.75-8.75 8.75m0-16c-3.998 0-7.25 3.252-7.25 7.25s3.252 7.25 7.25 7.25 7.25-3.252 7.25-7.25S13.998 2.75 10 2.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lift3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M1.75 19c-.414 0-.75-.336-.75-.75v-7.778c0-.476.197-.938.541-1.266l2.224-2.122c.297-.286.774-.276 1.06.024.285.3.275.775-.025 1.06L2.577 10.29c-.05.048-.077.112-.077.182v7.778c0 .414-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M4.25 19.009c-.414 0-.75-.336-.75-.75v-6.443c0-.414.336-.75.75-.75s.75.336.75.75v6.443c0 .414-.336.75-.75.75M17.75 19h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2c.413 0 .75-.337.75-.75v-6.5c0-.413-.337-.75-.75-.75h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2C18.99 8 20 9.01 20 10.25v6.5c0 1.24-1.01 2.25-2.25 2.25M11.478 3h-.728V1.75c0-.414-.336-.75-.75-.75s-.75.336-.75.75V3h-.728C7.132 3 6 4.01 6 5.25v11.5C6 17.99 7.132 19 8.522 19h2.956C12.868 19 14 17.99 14 16.75V5.25C14 4.01 12.868 3 11.478 3M12.5 16.75c0 .406-.468.75-1.022.75H8.522c-.554 0-1.022-.344-1.022-.75V5.25c0-.406.468-.75 1.022-.75h2.956c.554 0 1.022.344 1.022.75z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.73 7c-.1 0-.2-.02-.29-.06s-.17-.09-.24-.16-.13-.15-.17-.24c-.03-.09-.05-.19-.05-.29s.02-.2.05-.29c.04-.09.1-.17.17-.24s.15-.12.24-.16c.19-.08.39-.08.58 0 .09.04.17.09.24.16.14.14.22.33.22.53s-.08.39-.22.53c-.07.07-.15.12-.24.16-.1.04-.19.06-.29.06M11.25 7c-.1 0-.2-.02-.29-.06-.09-.03-.17-.09-.24-.16s-.12-.15-.16-.24-.06-.19-.06-.29.02-.2.06-.29.09-.17.16-.24.15-.12.24-.16c.19-.08.4-.08.58 0 .09.04.17.09.24.16s.13.15.16.24c.04.09.06.19.06.29s-.02.2-.06.29c-.03.09-.09.17-.16.24s-.15.13-.24.16c-.09.04-.19.06-.29.06M8.73 10c-.1 0-.2-.02-.29-.06-.09-.03-.17-.09-.24-.16s-.13-.15-.16-.24c-.04-.09-.06-.19-.06-.29s.02-.2.06-.29c.03-.09.09-.17.16-.24s.15-.12.24-.16c.18-.08.39-.08.58 0 .09.04.17.09.24.16.14.14.22.33.22.53s-.08.39-.22.53c-.07.07-.15.13-.24.16-.1.04-.2.06-.29.06M11.25 10c-.1 0-.2-.02-.29-.06-.09-.03-.17-.09-.24-.16-.14-.14-.22-.33-.22-.53s.08-.39.22-.53c.07-.07.15-.12.24-.16.19-.08.4-.08.58 0 .09.04.17.09.24.16s.13.15.16.24c.04.09.06.19.06.29s-.02.2-.06.29c-.03.09-.09.17-.16.24s-.15.13-.24.16c-.09.04-.19.06-.29.06M8.73 13c-.1 0-.2-.02-.29-.06s-.17-.09-.24-.16c-.14-.14-.22-.33-.22-.53 0-.1.02-.19.05-.29.04-.09.1-.17.17-.24s.15-.12.24-.16c.28-.12.61-.05.82.16.07.07.12.15.16.24.04.1.06.19.06.29 0 .2-.08.39-.22.53s-.34.22-.53.22M11.25 13c-.19 0-.39-.08-.53-.22s-.22-.33-.22-.53c0-.1.02-.19.06-.29.04-.09.09-.17.16-.24.29-.28.78-.28 1.06 0 .14.14.22.33.22.53 0 .1-.02.2-.06.29s-.09.17-.16.24c-.14.14-.33.22-.53.22M8.73 16c-.2 0-.39-.08-.53-.22-.07-.07-.13-.15-.16-.24-.04-.09-.06-.19-.06-.29s.02-.19.06-.29c.03-.09.09-.17.16-.24.28-.28.77-.28 1.06 0 .07.07.12.15.16.24.04.1.06.19.06.29s-.02.2-.06.29-.09.17-.16.24c-.14.14-.34.22-.53.22M11.25 16c-.1 0-.19-.02-.29-.06-.09-.03-.17-.09-.24-.16s-.12-.15-.16-.24-.06-.19-.06-.29.02-.19.06-.29c.04-.09.09-.17.16-.24s.15-.12.24-.16c.19-.08.39-.08.58 0 .09.04.17.09.24.16s.13.15.16.24c.04.1.06.19.06.29 0 .2-.08.39-.22.53-.07.07-.15.13-.24.16-.09.04-.19.06-.29.06M15.75 12.5c-.1 0-.19-.02-.29-.06-.09-.04-.17-.09-.24-.16s-.12-.15-.16-.24-.06-.19-.06-.29.02-.19.06-.29c.04-.09.09-.17.16-.24s.15-.12.24-.16c.28-.12.61-.05.82.16.07.07.13.15.16.24.04.1.06.19.06.29s-.02.2-.06.29c-.03.09-.09.17-.16.24-.14.14-.33.22-.53.22M15.75 15.5c-.2 0-.39-.08-.53-.22s-.22-.33-.22-.53.08-.39.22-.53c.21-.21.54-.28.82-.16.09.04.17.09.24.16s.13.15.16.24c.04.1.06.19.06.29s-.02.2-.06.29c-.03.09-.09.17-.16.24-.14.14-.33.22-.53.22"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8Xxyi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.184 5.868-3.688-3.687c-.85-.85-2.333-.85-3.182 0l-9.498 9.497c-.876.876-.877 2.301-.002 3.178l2.482 2.492c.42.42 1.001.662 1.594.662h2.405c.593 0 1.172-.24 1.591-.66l8.299-8.3c.876-.878.876-2.305-.001-3.182M8.826 16.29c-.14.14-.333.22-.53.22H5.89c-.197 0-.391-.08-.531-.22l-2.483-2.492c-.291-.293-.291-.768.001-1.06l2.636-2.636 4.59 4.59c.057.057.125.093.193.128zm8.298-8.3-5.833 5.834c-.035-.068-.071-.136-.128-.193l-4.59-4.59 5.802-5.8c.282-.283.777-.283 1.06 0l3.688 3.688c.293.292.293.768 0 1.06M17.937 18.021H17.5c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h.437c.414 0 .75.336.75.75s-.336.75-.75.75M15.006 18.021H12.5c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h2.506c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l22kS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18 15.75v-3.72c0-.413-.336-.75-.75-.75s-.75.337-.75.75v3.72c0 .414-.336.75-.75.75H4.25c-.414 0-.75-.336-.75-.75V4.25c0-.414.336-.75.75-.75h3.811c.414 0 .75-.336.75-.75S8.475 2 8.061 2H4.25C3.01 2 2 3.01 2 4.25v11.5C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M19 1.75v4.243c0 .414-.336.75-.75.75s-.75-.336-.75-.75V3.56l-6.47 6.47c-.146.146-.338.219-.53.219s-.384-.073-.53-.22c-.293-.293-.293-.767 0-1.06l6.47-6.47h-2.433c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.243c.414 0 .75.336.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ldsyU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m19.636 9.47-3-3c-.293-.293-.768-.293-1.06 0s-.294.767 0 1.06l1.719 1.72h-9.15c-.415 0-.75.336-.75.75s.335.75.75.75h9.15l-1.72 1.72c-.293.293-.293.767 0 1.06.147.147.338.22.53.22s.384-.073.53-.22l3-3c.294-.293.294-.767 0-1.06"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.047 12.956c-.414 0-.75.336-.75.75v2.044c0 .413-.337.75-.75.75H3.25c-.413 0-.75-.337-.75-.75V4.25c0-.413.337-.75.75-.75h8.5c.413 0 .75.337.75.75v1.968c0 .414.336.75.75.75s.75-.336.75-.75V4.25C14 3.01 12.99 2 11.75 2h-8.5C2.01 2 1 3.01 1 4.25v11.5C1 16.99 2.01 18 3.25 18h8.297c1.24 0 2.25-1.01 2.25-2.25v-2.044c0-.414-.336-.75-.75-.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4rCzU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 1.28c-4.825 0-8.75 3.924-8.75 8.75s3.925 8.75 8.75 8.75 8.75-3.926 8.75-8.75S14.825 1.28 10 1.28m7.25 8.75q0 .359-.036.71l-5.918-4.299 3.038-2.21C16.1 5.555 17.25 7.657 17.25 10.03m-5.562 2.47H8.345L7.32 9.333l2.7-1.965 2.707 1.966zm1.237-9.1-6.09 4.43-1.164-3.603C6.881 3.322 8.376 2.78 10 2.78c1.041 0 2.03.225 2.925.622M4.461 5.362 6.768 12.5H3.193c-.282-.772-.443-1.602-.443-2.47 0-1.779.645-3.406 1.71-4.669M3.94 14h7.254l-1.075 3.273c-.04 0-.08.006-.12.006-2.532 0-4.762-1.307-6.06-3.279m7.832 3.051 2.23-6.79 2.863 2.079c-.782 2.316-2.701 4.107-5.093 4.711"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"euK87":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18.27 2.162c-.561-.669-1.332-1.058-2.168-1.095-.902-.012-1.814.335-2.504 1.026l-1.3 1.29c-.952-.5-2.162-.35-2.963.45l-.385.385c-.919.918-.97 2.369-.174 3.36L4.914 11.44l-3.16 3.16c-1.004 1.005-1.004 2.64 0 3.645.504.503 1.164.754 1.823.754.66 0 1.32-.25 1.823-.754l7.02-7.02c.465.382 1.028.585 1.598.585.646 0 1.294-.247 1.786-.739l.384-.384c.8-.8.95-2.004.454-2.957l1.208-1.187.004-.005c1.29-1.289 1.464-3.13.416-4.376M4.34 17.185c-.42.419-1.104.42-1.525 0s-.42-1.105.004-1.528l3.156-3.156 3.842-3.844 1.526 1.526zm12.457-11.71-1.664 1.634c-.143.141-.224.332-.225.533 0 .199.078.391.22.533.4.4.4 1.05 0 1.451l-.385.385c-.4.4-1.05.4-1.451 0L10.011 6.73c-.4-.4-.4-1.051 0-1.452l.385-.384c.2-.2.462-.3.725-.3s.526.1.726.3c.292.293.766.293 1.058.002l1.751-1.74c.395-.396.889-.611 1.38-.59.418.019.793.212 1.086.561.634.754.275 1.744-.325 2.348"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2sRPb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M12.25 8h3.25v.377c0 .414.336.75.75.75s.75-.336.75-.75V6.871c0-.6-.234-1.164-.659-1.59L12.72 1.658c-.426-.424-.99-.658-1.59-.658H5.25C4.01 1 3 2.01 3 3.25v12.5C3 16.99 4.01 18 5.25 18h3.42c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H5.25c-.414 0-.75-.336-.75-.75V3.25c0-.414.336-.75.75-.75H10v3.25C10 6.99 11.01 8 12.25 8m3.03-1.66c.046.047.074.105.106.16H12.25c-.414 0-.75-.336-.75-.75V2.614c.055.032.113.06.159.105z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 10.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.5 5.125h-1.875V17.5c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-1.875H12.5c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.875V12.5c0-.345.28-.625.625-.625s.625.28.625.625v1.875H17.5c.345 0 .625.28.625.625s-.28.625-.625.625"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1FyXF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m12.28 12.53-1.75 1.75c-.146.147-.338.22-.53.22s-.384-.073-.53-.22l-1.75-1.75c-.293-.293-.293-.767 0-1.06s.767-.293 1.06 0l.421.42c-.034-1.014-.5-1.993-1.328-2.642-1.518-1.193-3.722-.927-4.914.59-.315.402-.535.855-.652 1.347-.096.402-.502.651-.904.555-.403-.096-.651-.501-.555-.904.168-.703.481-1.35.931-1.924 1.702-2.169 4.852-2.547 7.02-.844 1.22.958 1.9 2.415 1.908 3.915l.513-.513c.293-.293.767-.293 1.06 0s.293.767 0 1.06M17 6.871v8.879c0 1.24-1.01 2.25-2.25 2.25h-9.5C4.01 18 3 16.99 3 15.75v-2c0-.414.336-.75.75-.75s.75.336.75.75v2c0 .414.336.75.75.75h9.5c.414 0 .75-.336.75-.75V8h-3.25C11.01 8 10 6.99 10 5.75V2.5H5.25c-.414 0-.75.336-.75.75v1.5c0 .414-.336.75-.75.75S3 5.164 3 4.75v-1.5C3 2.01 4.01 1 5.25 1h5.879c.6 0 1.164.234 1.59.658l3.622 3.623c.425.425.659.99.659 1.59M12.25 6.5h3.136c-.032-.055-.06-.113-.106-.16L11.66 2.72c-.046-.046-.104-.074-.159-.106V5.75c0 .414.336.75.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1Dl3M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.341 5.28 12.72 1.66c-.425-.426-.99-.66-1.59-.66H5.25C4.01 1 3 2.01 3 3.25v12.5C3 16.99 4.01 18 5.25 18h3.386c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H5.25c-.414 0-.75-.337-.75-.75V3.25c0-.413.336-.75.75-.75H10v3.25C10 6.99 11.01 8 12.25 8h3.25v.349c0 .414.336.75.75.75s.75-.336.75-.75V6.87c0-.592-.24-1.172-.659-1.59m-4.841.47V2.614c.055.032.113.06.159.106l3.621 3.62c.046.046.074.105.106.16H12.25c-.414 0-.75-.337-.75-.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 10.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m-2.452 6.611c.593-.692 1.473-1.101 2.413-1.077.967-.037 1.875.38 2.476 1.095-.595.682-1.46 1.121-2.437 1.121-.985 0-1.856-.447-2.452-1.139m2.264-5.238c.879-.052 1.633.618 1.685 1.497q.003.047.003.094c.024.853-.647 1.565-1.5 1.591-.879.052-1.633-.618-1.685-1.497s.618-1.634 1.497-1.685"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"b0jYl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M3.75 14c-.414 0-.75-.336-.75-.75v-10C3 2.01 4.01 1 5.25 1h6c.414 0 .75.336.75.75s-.336.75-.75.75h-6c-.414 0-.75.337-.75.75v10c0 .414-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m17.363 8.213-2.687-3.224C14.152 4.36 13.382 4 12.563 4H8.25C7.01 4 6 5.01 6 6.25v9.5C6 16.99 7.01 18 8.25 18h7.5c1.24 0 2.25-1.01 2.25-2.25V9.974c0-.642-.226-1.267-.637-1.761m-1.714.287H14.25c-.414 0-.75-.337-.75-.75V5.928l.023.022zm.101 8h-7.5c-.414 0-.75-.337-.75-.75v-9.5c0-.413.336-.75.75-.75H12v2.25C12 8.99 13.01 10 14.25 10h2.25v5.75c0 .413-.336.75-.75.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6kxa6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M8.999 18.729c-.36 0-.717-.099-1.037-.293C7.359 18.07 7 17.43 7 16.726V10.49c0-.186-.068-.364-.192-.501l-4.18-4.644c-.538-.59-.674-1.416-.349-2.152S3.305 2 4.11 2h11.782c.804 0 1.505.457 1.83 1.193s.19 1.562-.353 2.156l-4.176 4.64c-.124.137-.192.315-.192.501v5.046c0 .843-.465 1.609-1.213 1.997l-1.865.968c-.292.152-.609.228-.923.228M4.109 3.5c-.295 0-.418.209-.458.298s-.11.322.088.54l4.184 4.647c.372.413.577.948.577 1.505v6.236c0 .254.168.383.24.427.073.045.266.133.49.017l1.866-.969c.25-.13.404-.384.404-.665V10.49c0-.557.205-1.092.577-1.505l4.18-4.644c.202-.22.132-.453.092-.543s-.163-.298-.458-.298z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"frTYk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M15.99 6.806C15.886 3.587 13.243 1 10 1S4.114 3.587 4.01 6.806C2.214 7.844 1 9.78 1 12c0 3.309 2.691 6 6 6 1.094 0 2.116-.299 3-.812.884.513 1.906.812 3 .812 3.309 0 6-2.691 6-6 0-2.22-1.214-4.156-3.01-5.194m-3.189 3.688c-.264-1.015-.783-1.926-1.49-2.659C11.832 7.623 12.4 7.5 13 7.5c.5 0 .974.101 1.424.253-.188 1.107-.783 2.066-1.623 2.74M10 15.33c-.72-.65-1.232-1.516-1.417-2.506.455.11.928.176 1.417.176s.962-.065 1.417-.176c-.185.99-.698 1.857-1.417 2.506M5.576 7.753C6.026 7.6 6.5 7.5 7 7.5c.598 0 1.167.123 1.69.335-.708.733-1.227 1.644-1.491 2.659-.84-.675-1.435-1.634-1.623-2.741M10 11.5c-.5 0-.974-.101-1.424-.253C8.75 10.23 9.264 9.334 10 8.67c.736.664 1.25 1.559 1.424 2.577-.45.152-.924.253-1.424.253m0-9c2.2 0 4.028 1.588 4.417 3.676C13.962 6.066 13.489 6 13 6c-1.094 0-2.116.299-3 .812C9.116 6.299 8.094 6 7 6c-.489 0-.962.065-1.417.176C5.973 4.088 7.801 2.5 10 2.5M2.5 12c0-1.417.672-2.668 1.699-3.494.409 1.572 1.436 2.894 2.81 3.688.05 1.54.68 2.934 1.68 3.97-.522.213-1.09.336-1.689.336-2.481 0-4.5-2.019-4.5-4.5M13 16.5c-.598 0-1.167-.123-1.69-.335 1.002-1.037 1.63-2.43 1.68-3.97 1.375-.795 2.402-2.117 2.811-3.689C16.828 9.332 17.5 10.583 17.5 12c0 2.481-2.019 4.5-4.5 4.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lCGFj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M9.818 2.62c-.217.35-.68.46-1.032.242q-.212-.131-.444-.235c-.34-.151-.704-.256-1.083-.309-1.532-.214-3.009.493-3.834 1.748l.544-.16c.395-.116.814.11.931.507s-.11.815-.507.932l-2.325.685q-.105.03-.212.03c-.324 0-.623-.21-.72-.538L.452 3.198c-.117-.397.11-.814.508-.931.395-.116.814.11.932.507l.18.61C3.186 1.564 5.288.54 7.463.833c.521.072 1.023.217 1.495.428q.323.146.616.327c.353.218.461.68.243 1.032m1.905 5.93c-.14-.142-.33-.223-.529-.225l-2.786-.03H8.4c-.41 0-.745.33-.75.742-.004.414.329.753.743.758l.908.01c-.99 1.27-2.662 1.822-4.229 1.344-1.107-.34-2.003-1.145-2.456-2.211-.163-.382-.605-.555-.984-.397-.381.163-.559.604-.397.984.628 1.475 1.867 2.59 3.398 3.058.527.162 1.063.24 1.593.24 1.611 0 3.156-.726 4.191-2l-.01 1.03c-.006.414.327.752.741.757h.008c.41 0 .745-.33.75-.742l.03-2.785c.002-.198-.075-.39-.213-.532m7.338 9.471-4.306-4.305c.46-.594.825-1.274 1.032-2.044.837-3.118-1.018-6.338-4.137-7.177-1.51-.405-3.09-.2-4.444.582-1.355.781-2.325 2.044-2.73 3.548l-.033.126c-.1.401.157.762.559.862.403.1.821-.191.922-.592.302-1.125 1.023-2.063 2.031-2.644 1.01-.581 2.184-.734 3.307-.433 2.32.623 3.699 3.019 3.076 5.34-.302 1.122-1.024 2.062-2.032 2.643-1.007.58-2.182.736-3.308.431-.255-.068-.507-.16-.748-.276-.378-.175-.821-.017-1 .355-.178.375-.019.823.355 1 .325.154.663.279 1.005.37.507.136 1.017.202 1.52.202 1.31 0 2.562-.447 3.573-1.224L18 19.082c.146.146.338.22.53.22s.384-.073.53-.22c.294-.293.294-.768 0-1.06"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"83kmp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M17.69 2.678c-.195-.14-.447-.18-.675-.105l-.587.195c-1.096.305-2.25.285-3.337-.067l-2.727-.88c-1.21-.39-2.504-.459-3.741-.195l-2.123.45V1.75c0-.414-.336-.75-.75-.75S3 1.336 3 1.75v16.5c0 .414.336.75.75.75s.75-.336.75-.75v-4.617l2.433-.516c.984-.206 2.01-.154 2.97.156l2.728.881c.725.234 1.474.352 2.228.352.67 0 1.343-.093 2.006-.28l.62-.205c.307-.1.515-.387.515-.711V3.285c0-.24-.115-.467-.31-.607m-1.19 10.09-.073.024c-1.093.309-2.248.285-3.336-.065l-2.727-.881c-1.208-.39-2.501-.456-3.741-.196L4.5 12.1V3.608l2.434-.515c.982-.208 2.01-.154 2.969.156l2.727.88c1.25.404 2.572.462 3.87.166z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2IzpU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.75 2.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75.336-.75.75-.75.75.336.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.75 5.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75.336-.75.75-.75.75.336.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.75 8.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75.336-.75.75-.75.75.336.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.75 11.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75.336-.75.75-.75.75.336.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.75 14.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75.336-.75.75-.75.75.336.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.75 17.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75.336-.75.75-.75.75.336.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M3.266 16.099q-.369 0-.738-.122C1.6 15.662 1 14.825 1 13.845v-7.69c0-.98.6-1.817 1.528-2.132.931-.312 1.914-.013 2.51.766l2.94 3.844c.615.805.615 1.929 0 2.733l-2.94 3.846c-.44.573-1.089.887-1.772.887m.002-10.697c-.117 0-.21.027-.258.042-.12.041-.51.212-.51.711v7.69c0 .499.39.67.51.71.119.039.531.142.836-.254l2.94-3.846c.205-.268.205-.643 0-.911L3.846 5.7c-.183-.24-.405-.298-.578-.298",
                opacity: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.734 16.099c-.683 0-1.333-.314-1.771-.888l-2.94-3.844c-.616-.805-.616-1.929 0-2.733l2.94-3.846c.595-.778 1.577-1.077 2.509-.765C18.4 4.338 19 5.175 19 6.155v7.69c0 .98-.6 1.817-1.528 2.132q-.369.123-.738.122m-.002-10.697c-.173 0-.395.059-.578.297l-2.94 3.846c-.205.267-.205.642 0 .911l2.94 3.844c.305.4.717.295.836.256.12-.041.51-.212.51-.711v-7.69c0-.499-.39-.67-.51-.71-.048-.016-.141-.043-.258-.043"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4vT2q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M17.5 10.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75.75.336.75.75-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M14.5 10.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75.75.336.75.75-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.5 10.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75.75.336.75.75-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.5 10.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75.75.336.75.75-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M5.5 10.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75.75.336.75.75-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M2.5 10.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75.75.336.75.75-.336.75-.75.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 8.438c-.482 0-.964-.153-1.366-.46l-3.846-2.94c-.778-.596-1.078-1.581-.765-2.51C4.338 1.6 5.175 1 6.155 1h7.69c.98 0 1.817.6 2.132 1.528.313.929.013 1.914-.766 2.51l-3.844 2.94c-.403.307-.885.46-1.367.46M6.155 2.5c-.499 0-.67.39-.71.51-.04.119-.142.533.254.836l3.846 2.94c.268.205.642.205.911 0l3.844-2.94c.397-.303.296-.717.256-.836-.041-.12-.212-.51-.711-.51z",
                opacity: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M13.845 19h-7.69c-.98 0-1.817-.6-2.132-1.528-.313-.929-.013-1.914.766-2.51l3.844-2.94c.806-.615 1.929-.615 2.733 0l3.846 2.94c.778.596 1.078 1.581.765 2.51C15.662 18.4 14.825 19 13.845 19M10 13.06c-.161 0-.321.051-.456.154L5.7 16.154c-.397.303-.296.717-.256.836.041.12.212.51.711.51h7.69c.499 0 .67-.39.71-.51.04-.119.142-.533-.254-.836l-3.846-2.94c-.134-.103-.294-.153-.455-.153"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7YABU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M8.373 15.498H3.25c-.414 0-.75-.336-.75-.75v-8.25h14.25c.414 0 .75.337.75.75V9.07c0 .414.336.75.75.75s.75-.336.75-.75V7.248c0-1.24-1.01-2.25-2.25-2.25h-5.964c-.217 0-.424-.094-.566-.258L8.515 2.773c-.428-.492-1.048-.775-1.7-.775H3.25C2.01 1.998 1 3.008 1 4.248v10.5c0 1.24 1.01 2.25 2.25 2.25h5.123c.414 0 .75-.336.75-.75s-.336-.75-.75-.75m-5.123-12h3.565c.218 0 .425.094.567.258l1.076 1.242H2.5v-.75c0-.413.336-.75.75-.75"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 10.498c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m2.5 5.125h-1.875v1.875c0 .345-.28.625-.625.625s-.625-.28-.625-.625v-1.875H12.5c-.345 0-.625-.28-.625-.625s.28-.625.625-.625h1.875v-1.875c0-.345.28-.625.625-.625s.625.28.625.625v1.875H17.5c.345 0 .625.28.625.625s-.28.625-.625.625"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jYQ0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 5h-5.964c-.218 0-.424-.094-.566-.259L8.516 2.777C8.089 2.283 7.47 2 6.816 2H3.25C2.01 2 1 3.01 1 4.25v11c0 .965.785 1.75 1.75 1.75h5.623c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H2.75c-.138 0-.25-.112-.25-.25V6.5h14.25c.413 0 .75.337.75.75v1.822c0 .414.336.75.75.75s.75-.336.75-.75V7.25C19 6.01 17.99 5 16.75 5M2.5 4.25c0-.413.337-.75.75-.75h3.565c.218 0 .424.094.567.259L8.459 5H2.5z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M15 10.5c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.015-4.5-4.5-4.5m1.662 6.243c-.122.117-.278.176-.434.176-.164 0-.328-.064-.45-.19l-1.227-1.271c-.022-.022-.03-.05-.049-.075-.029-.04-.06-.079-.08-.126-.02-.05-.025-.104-.032-.158-.003-.026-.015-.049-.015-.076v-2c0-.344.28-.625.625-.625s.625.28.625.625v1.748l1.052 1.088c.24.25.233.645-.015.884"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"g0aKy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 5h-5.964c-.218 0-.424-.094-.566-.259L8.516 2.777C8.089 2.283 7.47 2 6.816 2H3.25C2.01 2 1 3.01 1 4.25v9.417c0 .414.336.75.75.75s.75-.336.75-.75V6.5h14.25c.413 0 .75.337.75.75v7.5c0 .413-.337.75-.75.75H11.5c-.414 0-.75.336-.75.75s.336.75.75.75h5.25c1.24 0 2.25-1.01 2.25-2.25v-7.5C19 6.01 17.99 5 16.75 5M2.5 4.25c0-.413.337-.75.75-.75h3.565c.218 0 .424.094.567.259L8.459 5H2.5z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M9.25 10.021h-3.5c-.414 0-.75.336-.75.75s.336.75.75.75h1.668L2.72 16.22c-.293.293-.293.767 0 1.06.146.147.338.22.53.22s.384-.073.53-.22l4.72-4.72v1.711c0 .415.336.75.75.75s.75-.335.75-.75v-3.5c0-.414-.336-.75-.75-.75"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"llhOx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M19.211 8.896C18.782 8.327 18.127 8 17.414 8H6.66c-.997 0-1.887.67-2.162 1.629l-1.65 5.737c-.204-.135-.347-.354-.347-.616V4.25c0-.413.336-.75.75-.75h3.565c.218 0 .425.095.567.257l1.701 1.969c.428.492 1.047.774 1.7.774h6.189c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-6.19c-.218 0-.424-.095-.566-.257l-1.7-1.969C8.086 2.282 7.467 2 6.814 2H3.25C2.01 2 1 3.01 1 4.25v10.5C1 15.99 2.01 17 3.25 17c.023 0 .043-.011.066-.013.02.001.037.013.057.013h12.748c.998 0 1.887-.67 2.162-1.629l1.294-4.5c.197-.684.064-1.404-.366-1.975m-1.076 1.561-1.294 4.5c-.092.32-.388.543-.72.543H4.369l1.569-5.457c.092-.32.389-.543.721-.543h10.755c.238 0 .456.11.6.299.142.19.187.43.121.658"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hGSuR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m19.28 18.222-1.974-1.975c.437-.64.694-1.414.694-2.247 0-2.206-1.794-4-4-4s-4 1.794-4 4 1.794 4 4 4c.832 0 1.604-.256 2.245-.692l1.975 1.974c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M11.5 14c0-1.379 1.121-2.5 2.5-2.5s2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5-2.5-1.121-2.5-2.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M16.75 5.021h-5.964c-.218 0-.424-.094-.566-.258L8.516 2.797c-.428-.493-1.047-.776-1.7-.776H3.25C2.01 2.021 1 3.031 1 4.271v11c0 .965.785 1.75 1.75 1.75h5.428c.414 0 .75-.335.75-.75s-.336-.75-.75-.75H2.75c-.138 0-.25-.112-.25-.25v-8.75h14.25c.413 0 .75.337.75.75v2.152c0 .414.336.75.75.75s.75-.336.75-.75V7.27c0-1.24-1.01-2.25-2.25-2.25M2.5 4.271c0-.413.337-.75.75-.75h3.565c.218 0 .424.094.567.258l1.077 1.242H2.5z"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lVbjz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10.735 12.21 6.718 2.729c-.117-.277-.389-.458-.689-.458h-.002c-.3 0-.571.179-.69.455l-4.07 9.5c-.163.38.013.821.393.984q.146.061.296.061c.291 0 .567-.17.69-.455l1.185-2.765h4.36l1.163 2.744c.162.382.601.559.984.398.38-.162.56-.602.397-.983M4.473 8.551l1.55-3.617 1.533 3.617z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M18.576 14.757c-.536-2.076-2.846-2.036-4.086-2.018-.657.017-1.16-.125-1.321-.363-.101-.149-.105-.41-.037-.733.323.117.664.186 1.016.186h.051c1.649-.028 2.967-1.391 2.94-3.04-.006-.314-.072-.61-.167-.893h.578c.414 0 .75-.335.75-.75s-.336-.75-.75-.75h-1.7c-.495-.342-1.096-.547-1.75-.547-.8.013-1.544.337-2.1.91-.555.575-.853 1.33-.84 2.128.011.683.26 1.319.688 1.838-.35.993-.349 1.82.047 2.442-.666.438-1.36 1.194-1.382 2.274-.014.698.239 1.328.733 1.824.68.682 1.752 1.055 3.026 1.055h.11c1.624-.028 2.98-.602 3.723-1.575.466-.613.638-1.338.471-1.988M13.08 7.803c.276-.286.648-.448 1.046-.454h.024c.811 0 1.476.652 1.49 1.465.013.821-.644 1.5-1.465 1.514h-.026c-.388 0-.754-.148-1.035-.419-.286-.276-.447-.648-.453-1.046s.142-.775.42-1.06m3.832 8.032c-.455.598-1.41.965-2.555.984-.875.024-1.65-.214-2.047-.613-.205-.206-.302-.446-.296-.734.016-.826 1.085-1.25 1.091-1.253q.108-.04.195-.108c.334.087.731.136 1.217.128 1.98-.03 2.452.288 2.607.892.053.202-.025.46-.212.704"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"4j7PJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.75 15h-5.5C6.01 15 5 13.99 5 12.75v-5.5C5 6.01 6.01 5 7.25 5h5.5C13.99 5 15 6.01 15 7.25v5.5c0 1.24-1.01 2.25-2.25 2.25m-5.5-8.5c-.414 0-.75.336-.75.75v5.5c0 .414.336.75.75.75h5.5c.414 0 .75-.336.75-.75v-5.5c0-.414-.336-.75-.75-.75zM19 4.5h-2.25c-.69 0-1.25-.56-1.25-1.25V1c0-.414.336-.75.75-.75S17 .586 17 1v2h2c.414 0 .75.336.75.75s-.336.75-.75.75M3.25 4.5H1c-.414 0-.75-.336-.75-.75S.586 3 1 3h2V1c0-.414.336-.75.75-.75s.75.336.75.75v2.25c0 .69-.56 1.25-1.25 1.25M3.75 19.75c-.414 0-.75-.336-.75-.75v-2H1c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.25c.69 0 1.25.56 1.25 1.25V19c0 .414-.336.75-.75.75M3.25 17h.01zM16.25 19.75c-.414 0-.75-.336-.75-.75v-2.25c0-.69.56-1.25 1.25-1.25H19c.414 0 .75.336.75.75s-.336.75-.75.75h-2v2c0 .414-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6KAi8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M12.75 14.937h-5.5c-1.24 0-2.25-1.01-2.25-2.25v-5.5c0-1.241 1.01-2.25 2.25-2.25h5.5c1.24 0 2.25 1.009 2.25 2.25v5.5c0 1.24-1.01 2.25-2.25 2.25m-5.5-8.5c-.414 0-.75.336-.75.75v5.5c0 .413.336.75.75.75h5.5c.414 0 .75-.337.75-.75v-5.5c0-.414-.336-.75-.75-.75zM4.5 19H2.25C1.56 19 1 18.44 1 17.75V15.5c0-.414.336-.75.75-.75s.75.336.75.75v2h2c.414 0 .75.336.75.75s-.336.75-.75.75M17.75 19H15.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2v-2c0-.414.336-.75.75-.75s.75.336.75.75v2.25c0 .69-.56 1.25-1.25 1.25M18.25 5.25c-.414 0-.75-.336-.75-.75v-2h-2c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h2.25c.69 0 1.25.56 1.25 1.25V4.5c0 .414-.336.75-.75.75m-.5-2.75h.01zM1.75 5.25c-.414 0-.75-.336-.75-.75V2.25C1 1.56 1.56 1 2.25 1H4.5c.414 0 .75.336.75.75s-.336.75-.75.75h-2v2c0 .414-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eGxUY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m17.13 5.734-5.75-4.472c-.812-.631-1.948-.632-2.76 0L2.87 5.735h-.002C2.324 6.157 2 6.821 2 7.511v8.239C2 16.99 3.01 18 4.25 18h11.5c1.24 0 2.25-1.01 2.25-2.25V7.51c0-.689-.324-1.353-.87-1.776M11.5 16.5h-3v-4.75c0-.413.337-.75.75-.75h1.5c.413 0 .75.337.75.75zm5-.75c0 .413-.337.75-.75.75H13v-4.75c0-1.24-1.01-2.25-2.25-2.25h-1.5C8.01 9.5 7 10.51 7 11.75v4.75H4.25c-.413 0-.75-.337-.75-.75V7.51c0-.229.108-.45.29-.592l5.75-4.47c.272-.213.65-.21.92-.002l5.75 4.472c.182.142.29.363.29.593z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fxk0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 13.5c-.43 0-.86-.123-1.235-.37L2.729 9.166c-.635-.417-1.015-1.12-1.015-1.879 0-.76.38-1.464 1.015-1.882l6.036-3.966c.75-.492 1.72-.492 2.47 0l6.036 3.966c.636.418 1.015 1.121 1.015 1.882s-.38 1.462-1.015 1.879l-6.036 3.966c-.375.246-.805.369-1.235.369m-.412-1.623c.25.164.574.164.824 0l6.036-3.966c.215-.14.338-.369.338-.626s-.123-.485-.339-.627l-6.035-3.966c-.25-.164-.574-.164-.824 0L3.552 6.658c-.215.142-.338.37-.338.627s.123.486.338.626z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M10 19c-.43 0-.86-.123-1.235-.37l-6.036-3.965c-.577-.379-.942-.99-1.001-1.675-.06-.694.197-1.364.703-1.839.302-.282.777-.266 1.06.036s.268.777-.034 1.06c-.17.157-.254.382-.234.614.01.132.068.38.33.55l6.035 3.966c.25.164.574.164.824 0l6.036-3.966c.26-.17.319-.418.33-.55.02-.232-.066-.456-.235-.614-.302-.283-.317-.758-.034-1.06s.758-.318 1.06-.036c.507.475.763 1.145.703 1.84-.059.685-.424 1.295-1.001 1.674l-6.036 3.966C10.86 18.877 10.43 19 10 19"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2jxDj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M10 2.241c-.414 0-.75-.336-.75-.75v-.7c0-.414.336-.75.75-.75s.75.336.75.75v.7c0 .414-.336.75-.75.75M18.454 10.021h-.7c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h.7c.414 0 .75.336.75.75s-.336.75-.75.75M2.232 10.021h-.7c-.414 0-.75-.335-.75-.75s.336-.75.75-.75h.7c.414 0 .75.336.75.75s-.336.75-.75.75M4.51 4.54c-.192 0-.383-.074-.53-.22l-.495-.496c-.293-.293-.293-.767 0-1.06s.768-.293 1.06 0l.496.495c.293.293.293.767 0 1.06-.146.147-.338.22-.53.22M15.476 4.54c-.193 0-.384-.074-.53-.22-.294-.294-.294-.768 0-1.061l.494-.495c.293-.293.768-.293 1.061 0s.293.767 0 1.06l-.495.495c-.147.147-.338.22-.53.22M16 9.5c0-3.309-2.691-6-6-6s-6 2.691-6 6c0 2.216 1.21 4.15 3.001 5.189L7 14.695V16.5c0 1.654 1.346 3 3 3s3-1.346 3-3v-1.812c1.79-1.04 3-2.973 3-5.188m-4.5 7c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-1.198c.48.125.981.198 1.5.198s1.02-.073 1.5-.198zM10 14c-2.481 0-4.5-2.019-4.5-4.5S7.519 5 10 5s4.5 2.019 4.5 4.5S12.481 14 10 14"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a73RX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M1.75 6.771h2.669c.34 1.43 1.621 2.5 3.154 2.5s2.813-1.07 3.154-2.5h7.523c.414 0 .75-.335.75-.75s-.336-.75-.75-.75h-7.523c-.34-1.43-1.621-2.5-3.154-2.5s-2.814 1.07-3.154 2.5H1.75c-.414 0-.75.336-.75.75s.336.75.75.75m5.823-2.5c.965 0 1.75.786 1.75 1.75s-.785 1.75-1.75 1.75-1.75-.785-1.75-1.75.785-1.75 1.75-1.75M18.25 13.271h-2.523c-.34-1.43-1.621-2.5-3.154-2.5s-2.814 1.07-3.154 2.5H1.75c-.414 0-.75.336-.75.75s.336.75.75.75h7.669c.34 1.43 1.621 2.5 3.154 2.5s2.813-1.07 3.154-2.5h2.523c.414 0 .75-.335.75-.75s-.336-.75-.75-.75m-5.677 2.5c-.965 0-1.75-.785-1.75-1.75s.785-1.75 1.75-1.75 1.75.786 1.75 1.75-.785 1.75-1.75 1.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2xIVU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "M11.83 13H3.17c-.814 0-1.542-.42-1.949-1.125s-.406-1.546 0-2.25l4.33-7.5C5.959 1.421 6.688 1 7.5 1s1.542.42 1.949 1.125l4.33 7.5c.407.705.407 1.546 0 2.25S12.644 13 11.83 13M7.5 2.5c-.13 0-.454.036-.65.375l-4.33 7.5c-.195.339-.065.638 0 .75s.259.375.65.375h8.66c.391 0 .585-.262.65-.375s.195-.411 0-.75l-4.33-7.5c-.196-.339-.52-.375-.65-.375m-1.299 0h.01z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
                d: "m12.294 18.93-.133-.001c-2.354-.046-4.53-1.352-5.68-3.408-.203-.362-.073-.819.289-1.021.361-.203.817-.072 1.02.288.89 1.594 2.577 2.606 4.4 2.64 1.36.04 2.68-.483 3.672-1.437s1.552-2.238 1.579-3.614c.04-2.094-1.174-3.987-3.093-4.824-.38-.166-.553-.608-.388-.988s.608-.553.988-.387c2.477 1.08 4.045 3.525 3.993 6.228-.035 1.777-.759 3.434-2.04 4.666-1.248 1.2-2.88 1.858-4.607 1.858"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lJ2dl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 4.5H3.75c-.414 0-.75-.336-.75-.75S3.336 3 3.75 3h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M14.5 8.5h-9c-.414 0-.75-.336-.75-.75S5.086 7 5.5 7h9c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 12.5H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M14.5 16.5h-9c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h9c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lx2Ht":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 4.5H3.75c-.414 0-.75-.336-.75-.75S3.336 3 3.75 3h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 8.5H3.75c-.414 0-.75-.336-.75-.75S3.336 7 3.75 7h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 12.5H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 16.5H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6S5wg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 4.5H3.75c-.414 0-.75-.336-.75-.75S3.336 3 3.75 3h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M13.75 8.5h-10c-.414 0-.75-.336-.75-.75S3.336 7 3.75 7h10c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 12.5H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M13.75 16.5h-10c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cSNUd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 4.5H3.75c-.414 0-.75-.336-.75-.75S3.336 3 3.75 3h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 8.5h-10c-.414 0-.75-.336-.75-.75S5.836 7 6.25 7h10c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 12.5H3.75c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h12.5c.414 0 .75.336.75.75s-.336.75-.75.75M16.25 16.5h-10c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h10c.414 0 .75.336.75.75s-.336.75-.75.75"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8rVRU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18 18.204c-.414 0-.75-.336-.75-.75v-3.626l-.494.21c-.378.16-.821-.018-.983-.401-.16-.381.019-.822.4-.983l1.536-.647c.23-.097.496-.073.706.066s.335.374.335.625v4.756c0 .414-.336.75-.75.75M13.5 2h-9C3.26 2 2.25 3.01 2.25 4.25v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-.413.337-.75.75-.75h3.75v13H6.63c-.414 0-.75.336-.75.75s.336.75.75.75h4.64c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H9.75v-13h3.75c.413 0 .75.337.75.75v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25C15.75 3.01 14.74 2 13.5 2"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fplc4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M18 7.204c-.414 0-.75-.336-.75-.75V2.828l-.494.21c-.378.158-.821-.018-.983-.401-.16-.381.019-.822.4-.983l1.536-.647c.23-.098.496-.072.706.066.209.139.335.374.335.625v4.756c0 .414-.336.75-.75.75M12.5 2h-9C2.26 2 1.25 3.01 1.25 4.25v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25c0-.413.337-.75.75-.75h3.75v13H5.63c-.414 0-.75.336-.75.75s.336.75.75.75h4.64c.414 0 .75-.336.75-.75s-.336-.75-.75-.75H8.75v-13h3.75c.413 0 .75.337.75.75v1.11c0 .414.336.75.75.75s.75-.336.75-.75V4.25C14.75 3.01 13.74 2 12.5 2"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bZCJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M4.75 18h-.5C3.01 18 2 16.99 2 15.75v-2.5C2 12.01 3.01 11 4.25 11h.5C5.99 11 7 12.01 7 13.25v2.5C7 16.99 5.99 18 4.75 18m-.5-5.5c-.414 0-.75.336-.75.75v2.5c0 .414.336.75.75.75h.5c.414 0 .75-.336.75-.75v-2.5c0-.414-.336-.75-.75-.75zM8.75 9h-4.5C3.01 9 2 7.99 2 6.75v-2.5C2 3.01 3.01 2 4.25 2h4.5C9.99 2 11 3.01 11 4.25v2.5C11 7.99 9.99 9 8.75 9m-4.5-5.5c-.414 0-.75.336-.75.75v2.5c0 .414.336.75.75.75h4.5c.414 0 .75-.336.75-.75v-2.5c0-.414-.336-.75-.75-.75zM15.75 18h-4.5C10.01 18 9 16.99 9 15.75v-2.5C9 12.01 10.01 11 11.25 11h4.5c1.24 0 2.25 1.01 2.25 2.25v2.5c0 1.24-1.01 2.25-2.25 2.25m-4.5-5.5c-.414 0-.75.336-.75.75v2.5c0 .414.336.75.75.75h4.5c.414 0 .75-.336.75-.75v-2.5c0-.414-.336-.75-.75-.75zM15.75 9h-.5C14.01 9 13 7.99 13 6.75v-2.5C13 3.01 14.01 2 15.25 2h.5C16.99 2 18 3.01 18 4.25v2.5C18 7.99 16.99 9 15.75 9m-.5-5.5c-.414 0-.75.336-.75.75v2.5c0 .414.336.75.75.75h.5c.414 0 .75-.336.75-.75v-2.5c0-.414-.336-.75-.75-.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iwUs6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
"use client";
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M6.75 18h-2.5C3.01 18 2 16.99 2 15.75v-2.5C2 12.01 3.01 11 4.25 11h2.5C7.99 11 9 12.01 9 13.25v2.5C9 16.99 7.99 18 6.75 18m-2.5-5.5c-.413 0-.75.337-.75.75v2.5c0 .413.337.75.75.75h2.5c.413 0 .75-.337.75-.75v-2.5c0-.413-.337-.75-.75-.75zM6.75 9h-2.5C3.01 9 2 7.99 2 6.75v-2.5C2 3.01 3.01 2 4.25 2h2.5C7.99 2 9 3.01 9 4.25v2.5C9 7.99 7.99 9 6.75 9m-2.5-5.5c-.413 0-.75.337-.75.75v2.5c0 .413.337.75.75.75h2.5c.413 0 .75-.337.75-.75v-2.5c0-.413-.337-.75-.75-.75zM15.75 18h-2.5C12.01 18 11 16.99 11 15.75v-2.5c0-1.24 1.01-2.25 2.25-2.25h2.5c1.24 0 2.25 1.01 2.25 2.25v2.5c0 1.24-1.01 2.25-2.25 2.25m-2.5-5.5c-.413 0-.75.337-.75.75v2.5c0 .413.337.75.75.75h2.5c.413 0 .75-.337.75-.75v-2.5c0-.413-.337-.75-.75-.75zM15.75 9h-2.5C12.01 9 11 7.99 11 6.75v-2.5C11 3.01 12.01 2 13.25 2h2.5C16.99 2 18 3.01 18 4.25v2.5C18 7.99 16.99 9 15.75 9m-2.5-5.5c-.413 0-.75.337-.75.75v2.5c0 .413.337.75.75.75h2.5c.413 0 .75-.337.75-.75v-2.5c0-.413-.337-.75-.75-.75z"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=icons.0bdf6257.js.map
